import { DatePipe } from '@angular/common';
import {
  Component,
  Directive,
  HostListener,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  faMagnifyingGlass,
  faPlus,
  faRedo,
  faXmark,
} from '@fortawesome/free-solid-svg-icons';
import {
  CellClassParams,
  ColDef,
  FilterChangedEvent,
  GetContextMenuItemsParams,
  GridApi,
  GridOptions,
  GridReadyEvent,
  MenuItemDef,
  RowClickedEvent,
  RowGroupingDisplayType,
} from 'ag-grid-community';
import 'ag-grid-enterprise';
import { LicenseManager } from 'ag-grid-enterprise';
import * as luxon from 'luxon';
import { DateTime } from 'luxon';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import {
  catchError,
  debounceTime,
  EMPTY,
  fromEvent,
  interval,
  map,
  mapTo,
  ReplaySubject,
  shareReplay,
  startWith,
  Subscription,
  switchMap,
  takeWhile,
  timeout,
  timer,
} from 'rxjs';
import { Constants, FILE_UPLOAD_TIMEOUT, generateRandomString } from 'src/app/constants';
import { BorderCrossingComponent } from 'src/app/core/check/border-crossing/border-crossing.component';
import { CloseStatusComponent } from 'src/app/core/check/close-status/close-status.component';
import { DashboardSettingsComponent } from 'src/app/core/check/dashboard-settings/dashboard-settings.component';
import { DeletePopupComponent } from 'src/app/core/check/delete-popup/delete-popup.component';
import { EditEventComponent } from 'src/app/core/check/edit-event/edit-event.component';
import { CommonConstant } from 'src/app/core/constant/common.constant';
import { DefaultConstant } from 'src/app/core/constant/defaultPref.constant';
import { BorderCrossing } from 'src/app/core/grid-renderer/border-crossing';
import { DashCommentTooltip } from 'src/app/core/grid-renderer/dash-comment-tooltip/dash-comment-tooltip.component';
import { DashTooltip } from 'src/app/core/grid-renderer/dash-tooltip/dash-tooltip.component';
import { EditButtonComponent } from 'src/app/core/grid-renderer/edit-button/edit-button.component';
import { EventCommentRendererComponent } from 'src/app/core/grid-renderer/event-comment.grid-renderer';
import { OrderNumberComponent } from 'src/app/core/grid-renderer/order-number/order-number.component';
import { RefreshComponent } from 'src/app/core/grid-renderer/refresh/refresh.component';
import { AetStateService } from 'src/app/services/aet-state.service';
import { ButtonServiceService } from 'src/app/services/button-service.service';
import { DashboardService } from 'src/app/services/dashboard.service';
import { DataService } from 'src/app/services/data.service';
import { ExcelService } from 'src/app/services/excel.service';
import { MasterSettingsService } from 'src/app/services/master-settings.service';
import { DelayDispatchComponent } from '../delay-dispatch/delay-dispatch.component';
import { MatDialog } from '@angular/material/dialog';
import { FormControl } from '@angular/forms';
import { WebSocketService } from 'src/app/services/websocket.service';
import { environment } from 'src/environments/environment';
LicenseManager.setLicenseKey(
  'CompanyName=SHI International Corp._on_behalf_of_Toyota (Georgetown, KY),LicensedGroup=PR211836,LicenseType=MultipleApplications,LicensedConcurrentDeveloperCount=1,LicensedProductionInstancesCount=1,AssetReference=AG-034934,SupportServicesEnd=19_January_2024_[v2]_MTcwNTYyMjQwMDAwMA==ed32a72e5baa2524d9043f132656731f'
);
@Directive({
  selector: '#LIOS-grid',
  standalone: false // NOSONAR
})
export class PreventContextMenuInGrid {
  @HostListener('contextmenu', ['$event'])
  onContext(event: MouseEvent) {
    event.preventDefault();
  }
}

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  standalone: false // NOSONAR,
})
export class DashboardComponent implements OnInit, OnDestroy {
  private readonly defaultDateWindowDays = 4;
  private readonly unexpectedApiErrorMessage = 'An unexpected error occurred. Please retry. Contact IS Service Desk if error persists.';
  supplierNumber: any[] = [];
  domicileList: any[] = [];
  namcList: any[] = [];
  lineList: any[] = [];
  dockList: any[] = [];
  dateTypeList: any[] = [];
  timeZoneList: any[] = [];
  step: any;
  autoRefreshEnabled: boolean = true;
  gridApi: any;
  rowHeight = 30;
  defaultColDef: {};
  columnDefs: ColDef[] = [];
  paginationPageSize: any = 20;
  icons: {};
  rowClassRules: any;
  currentPageNo: number = 1;
  currentPageBoolean: boolean = false;
  totalPage: number = 0;
  displayRowData: any[] = [];
  currentPageForTotalPage!: number;
  isLastPageFound!: boolean;
  rowCount: number = 0;
  errorMessage: string;
  successMessage: string;
  preferenceData: any;
  // searchParameters: FormGroup;
  lpList: any[] = [];
  eventTypeList: any[] = [];
  problemTypeList: any[] = [];
  partNumberList: any[] = [];
  part: string;
  eventStatusList: any[] = [];
  dataList: any[] = [];
  faClearFilter = faXmark;
  faApplyFilter = faMagnifyingGlass;
  faAddEvent = faPlus;
  faRefreshButton = faRedo;
  tooltipShowDelay = 0;
  tooltipHideDelay = 30 * 60 * 1000;
  tooltipMouseTrack = true;
  selectedDomiciles: any[] = [];
  // selectedProblemTypes: any[] = [];
  selectedNamcList: any[] = [];
  selectedSupplierNumberList: any[] = [];
  selectedLineList: any[] = [];
  selectedLpList: any[] = [];
  selectedEventStatusList: any[] = [];
  selectedEventTypeList: any[] = [];
  selectedProblemTypeList: any[] = [];
  selectedDockList: any[] = [];
  selectedSupplierType: string = 'na';
  selectedTimeZone: string;
  fromDate: string;
  toDate: string;
  eventProblemMapping: any;
  eventProbTypeList: any[] = [];
  eventList: any[];
  eventTypId = [];
  maxDate: string;
  minDate: string;
  eventId: any;
  context: any;
  dashboardFilters: any;
  gridFilters: { [key: string]: any };
  preference: any;
  prefSeqId: number;
  defaultPreferenceArr = DefaultConstant.defaultDashboardPreferenceArr;
  dockListMapping: any[] = [];
  caList: any[] = [];
  naList: any[] = [];
  mtmList: any[] = [];
  supplierTypeCodeList: any[] = [];
  redTrigger: any;
  yellowTrigger: any;
  masterSettingResponse: any;
  public groupDisplayType: RowGroupingDisplayType = 'custom';
  public groupDefaultExpanded = 1;
  maximumStops: any = 5;
  isAccessible = true;
  masterSettingsEnabled: boolean = true;
  delayDispatchEnabled: boolean = true;
  isDSTChecked: boolean = false;
  currentTimeZone = 'EST';
  autoRefreshSubscription: Subscription;
  autoRefreshInterval: number; // in Seconds
  lineMapping: any;
  private inactivityTimer$ = timer(15 * 60 * 1000);
  private userActivitySubscription: Subscription;
  partError: string[] = [];
  maxDateDuration: number;
  fileName = '';
  upload: boolean = false;
  delayedDispatchRes: any;
  domicileFilterCtrl: FormControl = new FormControl();
  filteredDomiciles: ReplaySubject<any[]> = new ReplaySubject(1);
  namcFilterCtrl: FormControl = new FormControl();
  filterednamcs: ReplaySubject<any[]> = new ReplaySubject(1);
  supplierFilterCtrl: FormControl = new FormControl();
  filteredsuppliers: ReplaySubject<any[]> = new ReplaySubject(1);
  lineFilterCtrl: FormControl = new FormControl();
  filteredline: ReplaySubject<any[]> = new ReplaySubject(1);
  dockFilterCtrl: FormControl = new FormControl();
  filteredDock: ReplaySubject<any[]> = new ReplaySubject(1);
  lpFilterCtrl: FormControl = new FormControl();
  filteredLp: ReplaySubject<any[]> = new ReplaySubject(1);
  eventFilterCtrl: FormControl = new FormControl();
  filteredEvent: ReplaySubject<any[]> = new ReplaySubject(1);
  typeFilterCtrl: FormControl = new FormControl();
  filteredType: ReplaySubject<any[]> = new ReplaySubject(1);
  probFilterCtrl: FormControl = new FormControl(); const_not_started = 'Not Started'
  filteredProb: ReplaySubject<any[]> = new ReplaySubject(1); const_plnd_start = 'PLANNED RELOAD START'
  selectedFileName: any; const_planned = 'PLANNED RELOAD END'
  selectedFilePath: any; const_scanned = 'SCANNED ACTUAL'
  file_msg = "File is not uploaded...please try again"
  year_const = 'yyyy-MM-dd'; const_inprg = 'In Progress'; const_monhr = 'MM/dd/yyyy HH:mm'; const_arr = 'Arrived'
  constructor(
      private readonly dialog : MatDialog,
    private readonly buttonService: ButtonServiceService,
    private readonly service: MasterSettingsService,
    private readonly ngxUiLoaderService: NgxUiLoaderService,
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly dashboardService: DashboardService,
    private readonly datePipe: DatePipe,
    private readonly dataService: DataService,
    private readonly constants: Constants,
    private readonly excelService: ExcelService,
    private readonly aetStateService: AetStateService,
    private readonly webSocketService: WebSocketService
  ) {
    this.context = {
      componentParent: this,
    };

    this.defaultColDef = {
      suppressMovable: true,
      wrapHeaderText: true,
      autoHeight: true,
      filter: true,
      floatingFilter: true,
      tooltipComponent: DashTooltip,
      filterParams: { newRowsAction: 'keep' },
    };
    this.icons = {
      sortUnSort: '<img src="assets/images/Icon awesome-sort.svg">',
      groupExpanded:
        '<img src="assets/images/minus-square.svg"  style="height: 20px; width:20px;">',
      groupContracted:
        '<img src="assets/images/plus-square.svg" style="height: 20px; width:20px;">',
    };
    this.rowClassRules = {
      'row-even': 'node.rowIndex % 2 == 0',  // NOSONAR
      'row-odd': 'node.rowIndex % 2 != 0',            // NOSONAR
      'row-color': (params) =>
        params.data?.route_type?.toLowerCase() == 'ltl' ||  // NOSONAR
        params.data?.route_type?.toLowerCase() == 'only work instruction',  // NOSONAR
      // 'row-expanded': (params) =>
      //   params.data?.route_type !=   null || params.data?.route_type !=   undefined,
    };
  }
  ngOnDestroy(): void {
    this.autoRefreshSubscription?.unsubscribe();
    this.userActivitySubscription?.unsubscribe();
  }

  private setupInactivityDetection() {
    const userActivity$ = fromEvent(window, 'mousemove').pipe(
      mapTo(true),
      debounceTime(1000)
    );

    this.userActivitySubscription = userActivity$.pipe(switchMap(() => this.inactivityTimer$)).subscribe(() => {
      if (this.autoRefreshEnabled) {
        this.autoRefreshInterval = 0;
        this.autoRefreshEnabled = false;
        this.autoRefreshSubscription?.unsubscribe();
        alert(
          'You have been inactive for more than 15 minutes. Auto Refresh has been disabled.'
        );
      }
    });
  }

  ngOnInit(): void {
    this.setupInactivityDetection();
    // this.checkRoles();
    this.initializeDefaultDateRange();
    this.preferenceData = JSON.parse(JSON.stringify(this.defaultPreferenceArr));
    this.dateTypeList = [
      { description: 'Dispatch', code: 'D' },
      { description: 'Route', code: 'R' },
      { description: 'Unload', code: 'U' },
    ];
    this.timeZoneList = [
      { description: 'Eastern', code: 'E' },
      { description: 'Central', code: 'C' },
      { description: 'Mountain', code: 'M' },
      { description: 'Pacific', code: 'P' },
    ];
    this.supplierTypeCodeList = [
      { description: 'CA Code', code: 'ca' },
      { description: 'NA Code', code: 'na' },
      { description: 'MTM Code', code: 'mtm' },
    ];
    this.dashboardDropDownData();
    this.loadColumnPreferenceData();
    this.domicileFilterCtrl.valueChanges
      .pipe(

        startWith(''),
        map(search => search ? this.filterOption(search, this.domicileList) : this.domicileList?.slice())
      )
      .subscribe(filtered => {
        this.filteredDomiciles.next(filtered);
      });
    this.namcFilterCtrl.valueChanges
      .pipe(

        startWith(''),
        map(search => search ? this.filterOption(search, this.namcList) : this.namcList?.slice())
      )
      .subscribe(filtered => {
        this.filterednamcs.next(filtered);
      });
    this.supplierFilterCtrl.valueChanges
      .pipe(

        startWith(''),
        map(search => search ? this.filterOption(search, this.supplierNumber) : this.supplierNumber?.slice())
      )
      .subscribe(filtered => {
        this.filteredsuppliers.next(filtered);
      });
    this.lineFilterCtrl.valueChanges
      .pipe(

        startWith(''),
        map(search => search ? this.filterOption(search, this.lineList) : this.lineList?.slice())
      )
      .subscribe(filtered => {
        this.filteredline.next(filtered);
      });
    this.dockFilterCtrl.valueChanges
      .pipe(

        startWith(''),
        map(search => search ? this.filterOption(search, this.dockList) : this.dockList?.slice())
      )
      .subscribe(filtered => {
        this.filteredDock.next(filtered);
      });
    this.lpFilterCtrl.valueChanges
      .pipe(

        startWith(''),
        map(search => search ? this.filterOption(search, this.lpList) : this.lpList?.slice())
      )
      .subscribe(filtered => {
        this.filteredLp.next(filtered);
      });
    this.eventFilterCtrl.valueChanges
      .pipe(

        startWith(''),
        map(search => search ? this.filterOption(search, this.eventStatusList) : this.eventStatusList?.slice())
      )
      .subscribe(filtered => {
        this.filteredEvent.next(filtered);
      });
    this.typeFilterCtrl.valueChanges
      .pipe(

        startWith(''),
        map(search => search ? this.filterOption(search, this.eventTypeList) : this.eventTypeList?.slice())
      )
      .subscribe(filtered => {
        this.filteredType.next(filtered);
      });
    this.probFilterCtrl.valueChanges
      .pipe(

        startWith(''),
        map(search => search ? this.filterOption(search, this.problemTypeList) : this.problemTypeList?.slice())
      )
      .subscribe(filtered => {
        this.filteredProb.next(filtered);
      });
  }

  private getSavedFilterParams(): any | null {
    const raw = localStorage.getItem('filterParams');
    if (!raw) {
      return null;
    }

    try {
      const parsed = JSON.parse(raw);
      return parsed && typeof parsed === 'object' ? parsed : null;
    } catch (_error) {
      localStorage.removeItem('filterParams');
      return null;
    }
  }

  private initializeDefaultDateRange(
    dateLimit?: number,
    savedFrom?: string,
    savedTo?: string
  ): void {
    const effectiveDateRange = Math.max(Number(dateLimit) || 0, 60);

    const toDate = new Date();
    this.toDate = this.datePipe.transform(toDate, this.year_const);

    const minDate = new Date();
    minDate.setDate(minDate.getDate() - effectiveDateRange);
    this.minDate = this.datePipe.transform(minDate, this.year_const);

    const fromDate = new Date();
    fromDate.setDate(fromDate.getDate() - this.defaultDateWindowDays);
    this.fromDate = this.datePipe.transform(fromDate, this.year_const);

    const maxDate = new Date();
    maxDate.setDate(maxDate.getDate() + effectiveDateRange);
    this.maxDate = this.datePipe.transform(maxDate, this.year_const);

    if (savedFrom) {
      const parsedFrom = DateTime.fromFormat(savedFrom, this.date_Const);
      if (parsedFrom.isValid) {
        this.fromDate = parsedFrom.toFormat(this.year_const);
      }
    }

    if (savedTo) {
      const parsedTo = DateTime.fromFormat(savedTo, this.date_Const);
      if (parsedTo.isValid) {
        this.toDate = parsedTo.toFormat(this.year_const);
      }
    }
  }

  private filterOption(search: string, list: any): any[] {
    const filterValue = search.toLowerCase();
    return list.filter(d => d.description.toLowerCase().includes(filterValue));
  }

  // async checkRoles() {
  //   await this.aetStateService.getRoles();
  //   const roles = this.aetStateService.getroleState();
  //   const userRoles = JSON?.parse(roles);

  //   if (
  //     userRoles &&
  //     (userRoles.includes(this.constants.LIOS_UAC_Admin)))
  //     {
  //       this.delayDispatchEnabled = true;
  //     }

  //   if (
  //     userRoles &&
  //     (userRoles.includes(this.constants.LIOS_UAC_Admin) ||
  //       userRoles.includes(this.constants.LIOS_UAC_TEMA_Ops) ||
  //       userRoles.includes(this.constants.LIOS_UAC_NAMC_Planner) ||
  //       userRoles.includes(this.constants.LIOS_UAC_MTMUS_Planner))
  //   ) {
  //     this.masterSettingsEnabled = true;
  //    // this.delayDispatchEnabled = true;
  //   }
  //   if (
  //     userRoles &&
  //     (userRoles.includes(this.constants.LIOS_UAC_Admin) ||
  //       userRoles.includes(this.constants.LIOS_UAC_LP_Filter) ||
  //       userRoles.includes(this.constants.LIOS_UAC_TEMA_Ops) ||
  //       userRoles.includes(this.constants.LIOS_UAC_NAMC_Planner) ||
  //       userRoles.includes(this.constants.LIOS_UAC_AET_LP) ||
  //       userRoles.includes(this.constants.LIOS_UAC_MTMUS_Planner) ||
  //       userRoles.includes(this.constants.LIOS_UAC_MTMUS_Negotiator) ||
  //       userRoles.includes(this.constants.LIOS_UAC_Portal_Administrator) ||
  //       userRoles.includes(this.constants.LIOS_UAC_Reporting_Admin) ||
  //       userRoles.includes(this.constants.LIOS_UAC_Reporting_User) ||
  //       userRoles.includes(this.constants.LIOS_UAC_Route_Planner) ||
  //       userRoles.includes(this.constants.LIOS_UAC_SCV_Admin) ||
  //       userRoles.includes(this.constants.LIOS_UAC_Security_Admin) ||
  //       userRoles.includes(this.constants.LIOS_UAC_TEMA_AF) ||
  //       userRoles.includes(this.constants.LIOS_UAC_TEMA_Budgeting) ||
  //       userRoles.includes(this.constants.LIOS_UAC_TEMA_OPS_AM) ||
  //       userRoles.includes(this.constants.LIOS_UAC_TEMA_OPS_Specialist) ||
  //       userRoles.includes(this.constants.LIOS_UAC_TEMA_Purchasing) ||
  //       userRoles.includes(this.constants.LIOS_UAC_TEMA_LC) ||
  //       userRoles.includes(this.constants.LIOS_UAC_TPT_Admin) ||
  //       userRoles.includes(this.constants.LIOS_UAC_TSCS_Admin) ||
  //       userRoles.includes(this.constants.LIOS_UAC_WT_Administrator))
  //   ) {
  //     this.isAccessible = true;
  //   } else {
  //     this.router.navigate([`/home`]);
  //   }
  // }

  getContextMenuItems = (
    params: GetContextMenuItemsParams
  ): (any | MenuItemDef)[] => {
    if ( !params.node || params.node?.data.route_status == this.const_arr || params.node?.data.route_status == this.const_not_started || (params.node?.data.event_id != null && params.node?.data.route_id == null) ) {  // NOSONAR
      return [];
    }
    const result = {
      // custom item
      name: 'Close Route',
      action: () => this.openpopUp(params),
      cssClasses: ['redFont', 'bold'],
    };
    return [result];
  };

  openpopUp(params): void {
    const dialogRef = this.dialog?.open(CloseStatusComponent, {
      width: '480px',
      height: '300px',
      data: params,
    });
    dialogRef.afterClosed()?.subscribe((result: any) => {
      this.ngxUiLoaderService.stop(CommonConstant.loader);

      if (result?.event == 'CloseStatus') { // NOSONAR
        if (result?.responseType == 'success') { // NOSONAR
          this.gridDataFetch();
        } else {
          console.info('error');
        }
      }
    });
  }

  DSTCheck(event: any) {
    this.isDSTChecked = event.target.checked;
    let requiredTz = this.selectedTimeZone + 'ST';
    if (this.isDSTChecked) {
      requiredTz = requiredTz.replace('S', 'D');
    }
    this.getConvertedTimeZone(requiredTz);
  }

  onTimeZoneChange(event) {
    this.selectedTimeZone = event.value;
    let requiredTz = this.selectedTimeZone + 'ST';
    if (this.isDSTChecked) {
      requiredTz = requiredTz.replace('S', 'D');
    }
    this.getConvertedTimeZone(requiredTz);
  }

  convertTimeZone(neededTz) { // NOSONAR
    const x = this.displayRowData;
    this.displayRowData = null;
    this.displayRowData = x.map((item: any, _index: number) => {
      return {
        ...item,
        last_updated: this.dateTzConverter(item.last_updated, neededTz),
        unload_start: this.dateTzConverter(item.unload_start, neededTz),
        unload_end: this.dateTzConverter(item.unload_end, neededTz),
        eta: this.dateTzConverter(item.eta, neededTz),
        next_connection: this.dateTzConverter(item.next_connection, neededTz),
        stop_1_parts_reload_start: this.dateTzConverter(
          item.stop_1_parts_reload_start,
          neededTz
        ),
        stop_1_parts_reload_end: this.dateTzConverter(
          item.stop_1_parts_reload_end,
          neededTz
        ),
        stop_1_actual: this.dateTzConverter(item.stop_1_actual, neededTz),

        stop_2_parts_reload_start: this.dateTzConverter(
          item.stop_2_parts_reload_start,
          neededTz
        ),
        stop_2_parts_reload_end: this.dateTzConverter(
          item.stop_2_parts_reload_end,
          neededTz
        ),
        stop_2_actual: this.dateTzConverter(item.stop_2_actual, neededTz),

        stop_3_parts_reload_start: this.dateTzConverter(
          item.stop_3_parts_reload_start,
          neededTz
        ),
        stop_3_parts_reload_end: this.dateTzConverter(
          item.stop_3_parts_reload_end,
          neededTz
        ),
        stop_3_actual: this.dateTzConverter(item.stop_3_actual, neededTz),

        stop_4_parts_reload_start: this.dateTzConverter(
          item.stop_4_parts_reload_start,
          neededTz
        ),
        stop_4_parts_reload_end: this.dateTzConverter(
          item.stop_4_parts_reload_end,
          neededTz
        ),
        stop_4_actual: this.dateTzConverter(item.stop_4_actual, neededTz),

        stop_5_parts_reload_start: this.dateTzConverter(
          item.stop_5_parts_reload_start,
          neededTz
        ),
        stop_5_parts_reload_end: this.dateTzConverter(
          item.stop_5_parts_reload_end,
          neededTz
        ),
        stop_5_actual: this.dateTzConverter(item.stop_5_actual, neededTz),

        stop_6_parts_reload_start: this.dateTzConverter(
          item.stop_6_parts_reload_start,
          neededTz
        ),
        stop_6_parts_reload_end: this.dateTzConverter(
          item.stop_6_parts_reload_end,
          neededTz
        ),
        stop_6_actual: this.dateTzConverter(item.stop_6_actual, neededTz),

        stop_7_parts_reload_start: this.dateTzConverter(
          item.stop_7_parts_reload_start,
          neededTz
        ),
        stop_7_parts_reload_end: this.dateTzConverter(
          item.stop_7_parts_reload_end,
          neededTz
        ),
        stop_7_actual: this.dateTzConverter(item.stop_7_actual, neededTz),

        stop_8_parts_reload_start: this.dateTzConverter(
          item.stop_8_parts_reload_start,
          neededTz
        ),
        stop_8_parts_reload_end: this.dateTzConverter(
          item.stop_8_parts_reload_end,
          neededTz
        ),
        stop_8_actual: this.dateTzConverter(item.stop_8_actual, neededTz),

        stop_9_parts_reload_start: this.dateTzConverter(
          item.stop_9_parts_reload_start,
          neededTz
        ),
        stop_9_parts_reload_end: this.dateTzConverter(
          item.stop_9_parts_reload_end,
          neededTz
        ),
        stop_9_actual: this.dateTzConverter(item.stop_9_actual, neededTz),

        stop_10_parts_reload_start: this.dateTzConverter(
          item.stop_10_parts_reload_start,
          neededTz
        ),
        stop_10_parts_reload_end: this.dateTzConverter(
          item.stop_10_parts_reload_end,
          neededTz
        ),
        stop_10_actual: this.dateTzConverter(item.stop_10_actual, neededTz),

        dispatch_start_date: this.dateTzConverter(
          item.dispatch_start_date,
          neededTz
        ),
        dispatch_end_date: this.dateTzConverter(
          item.dispatch_end_date,
          neededTz
        ),

        yard_arrival_start: this.dateTzConverter(
          item.yard_arrival_start,
          neededTz
        ),
        yard_arrival_end: this.dateTzConverter(item.yard_arrival_end, neededTz),
        yard_arrival_actual: this.dateTzConverter(
          item.yard_arrival_actual,
          neededTz
        ),
        stop_1_delay_pickup: this.dateTzConverter(
          item.stop_1_delay_pickup,
          neededTz
        ),
        stop_1_delay_unload: this.dateTzConverter(
          item.stop_1_delay_unload,
          neededTz
        ),
        stop_2_delay_pickup: this.dateTzConverter(
          item.stop_2_delay_pickup,
          neededTz
        ),
        stop_2_delay_unload: this.dateTzConverter(
          item.stop_2_delay_unload,
          neededTz
        ),
        stop_3_delay_pickup: this.dateTzConverter(
          item.stop_3_delay_pickup,
          neededTz
        ),
        stop_3_delay_unload: this.dateTzConverter(
          item.stop_3_delay_unload,
          neededTz
        ),
        stop_4_delay_pickup: this.dateTzConverter(
          item.stop_4_delay_pickup,
          neededTz
        ),
        stop_4_delay_unload: this.dateTzConverter(
          item.stop_4_delay_unload,
          neededTz
        ),
        stop_5_delay_pickup: this.dateTzConverter(
          item.stop_5_delay_pickup,
          neededTz
        ),
        stop_5_delay_unload: this.dateTzConverter(
          item.stop_5_delay_unload,
          neededTz
        ),
        stop_6_delay_pickup: this.dateTzConverter(
          item.stop_6_delay_pickup,
          neededTz
        ),
        stop_6_delay_unload: this.dateTzConverter(
          item.stop_6_delay_unload,
          neededTz
        ),
        stop_7_delay_pickup: this.dateTzConverter(
          item.stop_7_delay_pickup,
          neededTz
        ),
        stop_7_delay_unload: this.dateTzConverter(
          item.stop_7_delay_unload,
          neededTz
        ),
        stop_8_delay_pickup: this.dateTzConverter(
          item.stop_8_delay_pickup,
          neededTz
        ),
        stop_8_delay_unload: this.dateTzConverter(
          item.stop_8_delay_unload,
          neededTz
        ),
        stop_9_delay_pickup: this.dateTzConverter(
          item.stop_9_delay_pickup,
          neededTz
        ),
        stop_9_delay_unload: this.dateTzConverter(
          item.stop_9_delay_unload,
          neededTz
        ),
        stop_10_delay_pickup: this.dateTzConverter(
          item.stop_10_delay_pickup,
          neededTz
        ),
        stop_10_delay_unload: this.dateTzConverter(
          item.stop_10_delay_unload,
          neededTz
        ),
        delay_unload: this.dateTzConverter(item.delay_unload, neededTz),
      };
    });
    this.currentTimeZone = neededTz;
    this.gridApi.applyTransaction({ update: this.displayRowData });
    this.ngxUiLoaderService.stop(CommonConstant.loader);
    this.rowCount = this.gridApi.getDisplayedRowCount();
    this.gridApi?.redrawRows();
  const param = this.getSavedFilterParams() || {};
    param.currentTz = this.currentTimeZone;
    param.tz = this.selectedTimeZone;
    param.dst = this.isDSTChecked;
    localStorage.setItem('filterParams', JSON.stringify(param));
  }

  getConvertedTimeZone(neededTz) {
    this.successMessage = null;
    this.errorMessage = null;
    let fgaDetails: any = JSON.parse(sessionStorage.getItem('FGA'));
    let upn = fgaDetails?.user?.userPrincipalName;
    this.ngxUiLoaderService.start(CommonConstant.loader);
    this.dashboardService.getDashboardload(upn)?.subscribe(
      (_result) => {
        this.convertTimeZone(neededTz);
        this.ngxUiLoaderService.stop(CommonConstant.loader);
      },
      (_error) => {
        this.convertTimeZone(neededTz);
        this.ngxUiLoaderService.stop(CommonConstant.loader);
      }
    );
  }

  dateTzConverter(date: string, neededTz: string) {
    if (date == undefined || date == null) {  // NOSONAR 
      return null;
    }
    const test = luxon.DateTime.fromFormat(
      date.substring(0, 16),
      this.const_monhr,
      { zone: this.constants.timeZones[this.currentTimeZone], setZone: true }
    );
    return (
      test
        .setZone(this.constants.timeZones[neededTz])
        .toFormat(this.const_monhr) + ` (${neededTz})`
    );
  }

  dashboardDropDownData() { // NOSONAR
    this.ngxUiLoaderService.start(CommonConstant.loader);
    this.buttonService.loadFilterValues().subscribe((response: any) => { // NOSONAR
      const param = this.getSavedFilterParams();
      response.domiciles.sort(function (a, b) {
        a = a.itemCode?.toLowerCase();
        b = b.itemCode?.toLowerCase();

        if (a < b) {
        return -1;
      }

      if (a > b) {
        return 1;
      }

      return 0;
      });
      response.domiciles.forEach((element) => {
        if (!element.itemCode.includes('PDC') && element.itemCode != 'TMMNK') {     // NOSONAR
          this.domicileList.push({
            description: element.itemCode,
            code: element.itemCode,
          });
        }
      });
      this.filteredDomiciles.next(this.domicileList?.slice());
      response.namcs.forEach((element) => {
        if (element.itemCode != '01KPW' && element.itemCode != '26MAZ') {      // NOSONAR
          this.namcList.push({
            description: element.itemCode,
            code: element.itemCode,
          });
        }
      });
      this.namcList.sort(function (a, b) {
        a = a.description?.toLowerCase();
        b = b.description?.toLowerCase();

        if (a < b) {
        return -1;
      }

      if (a > b) {
        return 1;
      }

      return 0;
      });

      this.lineMapping = response.lines;
      this.dockListMapping = response.namcDockMap;
      let tempList = [];
      let tempLine = [];
      for (const element of this.namcList) {
        const tempLineObj = this.lineMapping[`${element.description}`];
        if (tempLineObj) {
          for (const element of tempLineObj) {
            tempLine.push({
              description: element,
              code: element,
            });
          }
        }
        this.filterednamcs.next(this.namcList?.slice());

        const tempDockList = this.dockListMapping[`${element.description}`];
        if (tempDockList) {
          for (const element of tempDockList) {
            tempList.push({
              description: element,
              code: element,
            });
          }
        }
      }
      const tempLineUnique = tempLine.filter(
        (obj, index, self) =>
          index == self.findIndex((o) => o.description == obj.description) // NOSONAR
      );
      tempLine = tempLineUnique;
      tempLine.sort(function (a, b) {
        a = a.description?.toLowerCase();
        b = b.description?.toLowerCase();

        if (a < b) {
        return -1;
      }

      if (a > b) {
        return 1;
      }

      return 0;
      });
      this.lineList = tempLine;
      this.filteredline.next(this.lineList?.slice());


      const tempListUnique = tempList.filter(
        (obj, index, self) =>
          index == self.findIndex((o) => o.description == obj.description)  // NOSONAR
      );
      tempList = tempListUnique;
      tempList.sort(function (a, b) {
        a = a.description?.toLowerCase();
        b = b.description?.toLowerCase();

        if (a < b) {
        return -1;
      }

      if (a > b) {
        return 1;
      }

      return 0;
      });
      this.dockList = tempList;
      this.filteredDock.next(this.dockList?.slice());


      response.cacodes.forEach((element) => {
        this.caList.push({ description: element, code: element });
      });

      response.nacodes.forEach((element) => {
        this.naList.push({ description: element, code: element });
      });

      response.mtmcodes.forEach((element) => {
        this.mtmList.push({ description: element, code: element });
      });

      response.vendorNames.sort(function (a, b) {
        a = a.vendorName?.toLowerCase();
        b = b.vendorName?.toLowerCase();

        if (a < b) {
        return -1;
      }

      if (a > b) {
        return 1;
      }

      return 0;
      });
      response.vendorNames.forEach((element) => {
        this.lpList.push({
          description: element.vendorName,
          code: element.vendorId,
        });
        this.filteredLp.next(this.lpList?.slice());

      });

      response.eventTypes.forEach((element) => {
        this.eventTypeList.push({
          description: element.description,
          code: element.eventTypeId,
        });
        this.filteredType.next(this.eventTypeList?.slice());

      });
      this.eventTypeList.sort(function (a, b) {
        a = a.description?.toLowerCase();
        b = b.description?.toLowerCase();
        if (a == 'other') { return 1; } // NOSONAR
        if (b == 'other') { return -1; }  // NOSONAR
        if (a < b) {
        return -1;
      }

      if (a > b) {
        return 1;
      }

      return 0;
      });

      response.problemTypes.sort(function (a, b) {
        a = a.description?.toLowerCase();
        b = b.description?.toLowerCase();
        if (a == 'other') { return 1; }  // NOSONAR
        if (b == 'other') { return -1; }  // NOSONAR
        if (a < b) {
        return -1;
      }

      if (a > b) {
        return 1;
      }

      return 0;
      });
      response.problemTypes.forEach((element) => {
        this.problemTypeList.push({
          description: element.description,
          code: element.problemTypeId,
        });
        this.filteredProb.next(this.problemTypeList?.slice());

      });
      this.eventProblemMapping = response.eventProblemMappings;
      this.eventTypeList.forEach((element) => {
        const mapping = {
          code: element.code,
          eventType: element.description,
          problemTypes: [],
        };
        const problemIds = this.eventProblemMapping.filter(
          (value: any) => value.eventTypeId == element.code   // NOSONAR
        );
        const problems = [];
        problemIds.forEach((element2) => {
          const id = element2.problemTypeId;
          const type = this.problemTypeList.find((value) => value.code == id);  // NOSONAR
          if (type != undefined) {    // NOSONAR
            problems.push(type);
          }
        });
        mapping.problemTypes = problems;
        this.eventProbTypeList.push(mapping);
      });

      this.eventStatusList = [
        { description: this.const_arr, code: this.const_arr },
        { description: this.const_inprg, code: this.const_inprg },
        { description: 'Late', code: 'Late' },
        { description: this.const_not_started, code: this.const_not_started },
      ];
      this.filteredEvent.next(this.eventStatusList?.slice());

      if (param) {
        this.selectedDomiciles = this.domicileList.filter(d => (param.domicile ?? []).some((p: any) => p.code === d.code));
        this.selectedNamcList = this.namcList.filter(d => (param.namc ?? []).some((p: any) => p.code === d.code));
        this.selectedSupplierType = param.supplierType;
        this.selectedLineList = this.lineList.filter(d => (param.line ?? []).some((p: any) => p.code === d.code));
        this.selectedDockList = this.dockList.filter(d => (param.dock ?? []).some((p: any) => p.code === d.code));
        this.selectedLpList = this.lpList.filter(d => (param.lp ?? []).some((p: any) => p.code === d.code));
        this.selectedEventStatusList = this.eventStatusList.filter(d => (param.status ?? []).some((p: any) => p.code === d.code));
        this.selectedEventTypeList = this.eventTypeList.filter(d => (param.event ?? []).some((p: any) => p.code === d.code));
        this.selectedProblemTypeList = this.problemTypeList.filter(d => (param.problem ?? []).some((p: any) => p.code === d.code));
        this.selectedTimeZone = param.tz;
        this.isDSTChecked = param.dst;
        this.currentTimeZone = param.currentTz;
      } else {
        this.selectedDomiciles = [];
        this.selectedNamcList = [];
        this.selectedSupplierType = 'na';
        this.selectedSupplierNumberList = [];
        this.selectedLineList = [];
        this.selectedDockList = [];
        this.selectedLpList = [];
        this.selectedEventStatusList = [];
        this.selectedEventTypeList = [];
        this.selectedProblemTypeList = [];
        this.selectedTimeZone = 'E';
        this.isDSTChecked = false;
        this.currentTimeZone = 'EST';
      }

      this.initializeDefaultDateRange(response.dateLimit, param?.from, param?.to);

      if (this.selectedSupplierType == 'na') {  // NOSONAR
        this.supplierNumber = this.naList;
      } else if (this.selectedSupplierType == 'ca') {  // NOSONAR
        this.supplierNumber = this.caList;
      } else {
        this.supplierNumber = this.mtmList;
      }
      this.filteredsuppliers.next(this.supplierNumber?.slice());
      if (param) {
        this.selectedSupplierNumberList = this.supplierNumber.filter(d => (param.supplier ?? []).some((p: any) => p.code === d.code));
      }

      this.part = localStorage.getItem('filterParamsPart');
      this.part = this.part == null ? '' : this.part;  // NOSONAR
      const flag = localStorage.getItem('backFlag');
      if (flag != null || flag != undefined) {   // NOSONAR
        localStorage.removeItem('backFlag');
        this.gridDataFetch();
      } else {
        this.ngxUiLoaderService.stop(CommonConstant.loader);
      }
    }, (_error) => {
      this.ngxUiLoaderService.stop(CommonConstant.loader);
      this.errorMessage = 'An unexpected error occurred. Please retry. Contact IS Service Desk if error persists.';
      this.successMessage = null;
      this.displayRowData = [];
      this.rowCount = 0;
      this.gridApi?.setRowData([]);
    });
    this.settingsDataMap();
  }

  onEventTypeChange() {
    this.eventList = [];
    this.eventTypId = [];
    this.problemTypeList = [];
    let worklist = [];
    if (this.selectedEventTypeList.length == 0) {  // NOSONAR
      worklist = this.eventTypeList;
    } else {
      worklist = this.selectedEventTypeList;
    }
    worklist.forEach((ele) => {
      this.eventTypId.push(ele.code);
    });
    for (const eventTypeId of this.eventTypId) {
      const selectedEvent = this.eventProbTypeList.find(
        (obj) => obj.code == eventTypeId  // NOSONAR
      );
      for (const element in selectedEvent) {
        if (element == 'problemTypes') {  // NOSONAR
          selectedEvent[element].forEach((ele) => {
            this.problemTypeList.push(ele);
          });
          this.filteredProb.next(this.problemTypeList?.slice());

        }
      }
    }
  }

  clearFilter() {
    this.selectedDomiciles = [];
    this.selectedNamcList = [];
    this.selectedSupplierType = 'na';
    this.supplierNumber = this.naList;
    this.selectedSupplierNumberList = [];
    this.selectedLineList = [];
    this.selectedDockList = [];
    this.onNamcSelected();
    this.selectedLpList = [];
    this.selectedEventStatusList = [];
    this.selectedEventTypeList = [];
    this.selectedProblemTypeList = [];
    localStorage.removeItem('filterParams');
    this.initializeDefaultDateRange();
  }
  onNamcSelected() {
    let tempList = [];
    let worklist = [];
    let tempLine = [];
    if (this.selectedNamcList.length == 0) {  // NOSONAR
      worklist = this.namcList;
    } else {
      worklist = this.selectedNamcList;
    }
    for (const element of worklist) {
      const tempDockList = this.dockListMapping[`${element.description}`];
      const tempLineObj = this.lineMapping[`${element.description}`];
      if (tempDockList) {
        for (const element of tempDockList) {
          tempList.push({
            description: element,
            code: element,
          });
        }
      }
      if (tempLineObj) {
        for (const element of tempLineObj) {
          tempLine.push({
            description: element,
            code: element,
          });
        }
      }
    }
    const tempListUnique = tempList.filter(
      (obj, index, self) =>
        index == self.findIndex((o) => o.description == obj.description)  // NOSONAR
    );
    tempList = tempListUnique;
    tempList = tempList.sort(function (a, b) {
      a = a.description?.toLowerCase();
      b = b.description?.toLowerCase();

      if (a < b) {
        return -1;
      }

      if (a > b) {
        return 1;
      }

      return 0;
    });
    this.dockList = tempList;
    this.filteredDock.next(this.dockList?.slice());

    const tempLineUnique = tempLine.filter(
      (obj, index, self) =>
        index == self.findIndex((o) => o.description == obj.description)  // NOSONAR
    );
    tempLine = tempLineUnique;
    tempLine = tempLine.sort(function (a, b) {
      a = a.description?.toLowerCase();
      b = b.description?.toLowerCase();

      if (a < b) {
        return -1;
      }

      if (a > b) {
        return 1;
      }

      return 0;
    });
    this.lineList = tempLine;
    this.filteredline.next(this.lineList?.slice());

  }

  onTypeChange(e) {
    this.selectedSupplierType = e.value;
    this.selectedSupplierNumberList = [];
    if (this.selectedSupplierType == 'ca') {  // NOSONAR
      this.supplierNumber = [];
      this.supplierNumber = this.caList;
    } else if (this.selectedSupplierType == 'mtm') { // NOSONAR
      this.supplierNumber = [];
      this.supplierNumber = this.mtmList;
    } else {
      this.supplierNumber = [];
      this.supplierNumber = this.naList;
    }
    this.supplierNumber.sort(function (a, b) {
      a = a.description?.toLowerCase();
      b = b.description?.toLowerCase();

      if (a < b) {
        return -1;
      }

      if (a > b) {
        return 1;
      }

      return 0;

    });
    this.filteredsuppliers.next(this.supplierNumber?.slice());

  }

  loadColumnPreferenceData() {
    const toyotaGUID = localStorage.getItem('toyotaGUID');
    let fgaDetails: any = JSON.parse(sessionStorage.getItem('FGA'));
    let roles = fgaDetails?.roles;
    let roleNames = fgaDetails?.roles?.map(role => role.displayName);
    let upn = fgaDetails?.user?.userPrincipalName;
    this.successMessage = null;
    this.errorMessage = null;
    this.dashboardService.getDashboardload(upn)?.subscribe(
      (response) => {
        this.preference = response;
        if (this.preference.length) {
          const localPref: any[] = JSON.parse(
            JSON.stringify(this.defaultPreferenceArr)
          );
          this.prefSeqId = this.preference[0].prefSeqId;
          if (this.preference.length == localPref.length) { // NOSONAR
            this.preferenceData = this.preference;
          } else {
            this.preferenceData = this.preference;
            const availablePref = this.preferenceData.map((val) => val.name);
            const filterList = localPref.filter(
              (obj) => !availablePref.includes(obj.name)
            );
            this.preferenceData = this.preferenceData.concat(filterList);
          }
        } else {
          this.preferenceData = JSON.parse(
            JSON.stringify(this.defaultPreferenceArr)
          );
          this.prefSeqId = 0;
        }

        this.getColDefs();
      },
      (err) => {
        console.info(err);
        this.showError(this.getApiErrorMessage(err));
      }
    );
  }
  openMasterConfig() {
    this.router?.navigate([`/dashboard/master-config`]);
  }

  openSettings() {
    this.dialog
      .open(DashboardSettingsComponent, {
        width: '25%',
        height: '395px',
        data: {
          coldef: this.preferenceData,
        },
      })
      .afterClosed()
      .subscribe((result) => {
        if (result.button == 'SAVE') {  // NOSONAR
          this.preferenceData = result.data;
          this.saveColumnPreference();
        } else if (result.button == 'RESET') {  // NOSONAR
          this.preferenceData = JSON.parse(
            JSON.stringify(this.defaultPreferenceArr)
          );
          this.saveColumnPreference();
        }
      });
  }

  getTimezone() {
    const td = luxon.DateTime.fromJSDate(new Date()).setZone(
      this.constants.timeZones[this.currentTimeZone]
    );
    const toDate = td.toFormat(this.const_monhr);
    return toDate;
  }

  getDynamicStopColumns(item: any) {
    let maxStops;
    if (item.stop_1_nacode == null) {  // NOSONAR 
      maxStops = 0;
    } else if (item.stop_2_nacode == null) {  // NOSONAR
      maxStops = 1;
    } else if (item.stop_3_nacode == null) {  // NOSONAR
      maxStops = 2;
    } else if (item.stop_4_nacode == null) {  // NOSONAR
      maxStops = 3;
    } else if (item.stop_5_nacode == null) {  // NOSONAR
      maxStops = 4;
    } else if (item.stop_6_nacode == null) {  // NOSONAR
      maxStops = 5;
    } else if (item.stop_7_nacode == null) {  // NOSONAR
      maxStops = 6;
    } else if (item.stop_8_nacode == null) {  // NOSONAR
      maxStops = 7;
    } else if (item.stop_9_nacode == null) {  // NOSONAR
      maxStops = 8;
    } else if (item.stop_10_nacode == null) {  // NOSONAR
      maxStops = 9;
    } else {
      maxStops = 10;
    }
    this.maximumStops =
      this.maximumStops > maxStops ? this.maximumStops : maxStops;
  }

  customSortingForNullVal(a, b, isInverted) {
    if (a == null) {  // NOSONAR
      return isInverted ? -1 : 1;
    } else if (b == null) {  // NOSONAR
      return isInverted ? 1 : -1;
    } else {
      return a?.localeCompare(b);
    }
  }

  customSortingBorderCrossing(a, b, isInverted) {
    // console.info('value..',a,b,typeof(a),typeof(b))
    if (a == null) {  // NOSONAR
      return isInverted ? -1 : 1;
    } else if (b == null) {  // NOSONAR
      return isInverted ? 1 : -1;
    } else {
      return a - b;
    }
  }

  getColDefs() { // NOSONAR
    this.commonColumnDefs()
    const columns = this.commonColumns()
    const remainingStopColumns: ColDef[] = this.remainingcolumn()
    const remainingColumns: ColDef[] = [
      {
        headerName: 'YARD ARRIVAL',
        field: 'yard_arrival_start',
        floatingFilterComponentParams: { suppressFilterButton: true },
        floatingFilter: true,
        sortable: true,
        unSortIcon: true,
        filter: 'agTextColumnFilter',
        tooltipField: 'yard_name',
        tooltipComponentParams: { field: 'yard' },
        minWidth: 150,
        //maxWidth 160,
        cellStyle: function (params: CellClassParams) {
          const data = params.data;
          if (!data?.yard_nacode) { return {}; }

          const isSubRoute = data.route_type == 'Sub Route';  // NOSONAR

          // Decide start field
          const start = isSubRoute ? data.unload_start : data.yard_arrival_start;

          // Decide end field
          const end = data.yard_arrival_actual ??
            data.yard_arrival_eta ??
            data.currentDate;

          const status = data.cellChange(
            start,
            end,
            data.yellowTrigger,
            data.redTrigger
          );

          return getStyle(status, data.yard_arrival_actual, data.yard_arrival_eta);
        },

        valueGetter: (params) => {
          if (params.node.group) {
            return params.node.childrenAfterFilter[0].data.yard_arrival_start;
          }
          return params.data.yard_arrival_start;
        },
        comparator: (a, b, _nodeA, _nodeB, isInverted) => {
          return this.customSortingForNullVal(a, b, isInverted);
        },
      },
      {
        headerName: 'UNLOAD',
        field: 'unload_start',
        floatingFilterComponentParams: { suppressFilterButton: true },
        floatingFilter: true,
        filter: 'agTextColumnFilter',
        sortable: true,
        unSortIcon: true,
        tooltipField: 'unload_start',
        tooltipComponentParams: { field: 'unload' },
        minWidth: 150,
        //maxWidth 160,
        valueGetter: (params) => {
          if (params.node.group) {
            return params.node.childrenAfterFilter[0].data.unload_start;
          }
          return params.data.unload_start;
        },
        cellStyle: function (params: CellClassParams) {  // NOSONAR
          if (params.node.group) {
            return {};
          }
          if (
            !params.data?.namcList.includes({
              description: params.data?.yard_nacode,
              code: params.data?.yard_nacode,
            })
          ) {
            let cellChangeValue;
            if ( params.data?.yard_arrival_actual == undefined || params.data?.yard_arrival_actual == null ) {  // NOSONAR
              if ( params.data?.yard_arrival_eta == undefined || params.data?.yard_arrival_eta == null ) {  // NOSONAR
                cellChangeValue = params.data?.cellChange(
                  params.data?.unload_start,
                  params.data?.currentDate,
                  params.data?.yellowTrigger,
                  params.data?.redTrigger
                );
                if (cellChangeValue == 'lightgreen') {  // NOSONAR
                  return { color: 'black', backgroundColor: 'lightgreen' };
                } else if (cellChangeValue == 'yellow') {  // NOSONAR
                  return { color: 'white', backgroundColor: 'grey' };
                } else {
                  return { color: 'white', backgroundColor: 'grey' };
                }
              } else {
                cellChangeValue = params.data?.cellChange(
                  params.data?.unload_start,
                  params.data?.yard_arrival_eta,
                  params.data?.yellowTrigger,
                  params.data?.redTrigger
                );
                if (cellChangeValue == 'lightgreen') {  // NOSONAR
                  return { color: 'black', backgroundColor: 'lightgreen' };
                } else if (cellChangeValue == 'yellow') {  // NOSONAR
                  return { color: 'black', backgroundColor: 'amber' };
                } else {
                  return { color: 'black', backgroundColor: 'amber' };
                }
              }
            } else {
              cellChangeValue = params.data?.cellChange(
                params.data?.unload_start,
                params.data?.yard_arrival_actual,
                params.data?.yellowTrigger,
                params.data?.redTrigger
              );
              if (cellChangeValue == 'lightgreen') {  // NOSONAR
                return { color: 'black', backgroundColor: 'lightgreen' };
              } else if (cellChangeValue == 'yellow') {  // NOSONAR
                return { color: 'black', backgroundColor: 'yellow' }; 
              } else {
                return { color: 'white', backgroundColor: 'red' };
              }
            }
          }
          let cellChangeValue;
          if ( params.data?.unload_actual == undefined || params.data?.unload_actual == null ) {  // NOSONAR
            if ( params.data?.unload_eta == undefined || params.data?.unload_eta == null ) {  // NOSONAR
              cellChangeValue = params.data?.cellChange(
                params.data?.unload_start,
                params.data?.currentDate,
                params.data?.yellowTrigger,
                params.data?.redTrigger
              );
              if (cellChangeValue == 'lightgreen') {  // NOSONAR
                return { color: 'black', backgroundColor: 'lightgreen' };
              } else if (cellChangeValue == 'yellow') {  // NOSONAR
                return { color: 'white', backgroundColor: 'grey' };
              } else {
                return { color: 'white', backgroundColor: 'grey' };
              }
            } else {
              cellChangeValue = params.data?.cellChange(
                params.data?.unload_start,
                params.data?.unload_eta,
                params.data?.yellowTrigger,
                params.data?.redTrigger
              );
              if (cellChangeValue == 'lightgreen') {  // NOSONAR
                return { color: 'black', backgroundColor: 'lightgreen' };
              } else if (cellChangeValue == 'yellow') {  // NOSONAR
                return { color: 'black', backgroundColor: 'amber' };
              } else {
                return { color: 'black', backgroundColor: 'amber' };
              }
            }
          } else {
            cellChangeValue = params.data?.cellChange(
              params.data?.unload_start,
              params.data?.unload_actual,
              params.data?.yellowTrigger,
              params.data?.redTrigger
            );
            if (cellChangeValue == 'lightgreen') {  // NOSONAR
              return { color: 'black', backgroundColor: 'lightgreen' };
            } else if (cellChangeValue == 'yellow') {  // NOSONAR
              return { color: 'black', backgroundColor: 'yellow' };
            } else {
              return { color: 'white', backgroundColor: 'red' };
            }
          }
        },
        comparator: (a, b, _nodeA, _nodeB, isInverted) => {
          return this.customSortingForNullVal(a, b, isInverted);
        },
      },
      {
        headerName: 'ACTION',
        field: 'action',
        floatingFilterComponentParams: { suppressFilterButton: true },
        floatingFilter: false,
        minWidth: 110,
        //maxWidth 120,
        pinned: 'right',
        cellRenderer: EditButtonComponent,
      },
    ];
    this.preferenceData = this.preferenceData.sort((a, b) => {
      return a.colIndex - b.colIndex;
    });
    this.preferenceData.forEach((element) => {
      const value = columns[element.name];
      if (value) {
        value.hide = element.hidden;
        this.columnDefs.push(value);
      }
    });
    this.columnDefs = this.columnDefs.concat(
      remainingStopColumns.slice(0, this.maximumStops + 1)
    );
    this.columnDefs = this.columnDefs.concat(remainingColumns);
    this.dataService.user$.subscribe((filters) => {
      //this check is required only if the initial user is null
      if (!!filters) {
        this.dashboardFilters = filters;
        const retrivedValue = this.dashboardFilters.gridFilters;
        this.gridApi?.setFilterModel(retrivedValue);
        this.gridApi?.onFilterChanged();
        this.gridApi?.refreshCells();
      }
    });
  }

  commonColumnDefs() {
    this.columnDefs = [
      {
        floatingFilterComponent: RefreshComponent,
        floatingFilterComponentParams: { suppressFilterButton: true },
        minWidth: 40,
        maxWidth: 40,
        pinned: 'left',
      },
      // { field: 'groupBy', rowGroup: true, hide: true },
      {
        headerName: 'ROUTE',
        // field: 'groupBy',
        field: 'main_route',
        floatingFilterComponentParams: { suppressFilterButton: true },
        floatingFilter: true,
        filter: 'agTextColumnFilter',
        sortable: true,
        unSortIcon: true,
        showRowGroup: true,
        // cellRenderer: 'agGroupCellRenderer',
        // headerComponent: CustomHeaderComponent,
        // cellRendererParams: {
        //   innerRenderer: function (params) {
        //     if (params.node.group)
        //       return params.node.allLeafChildren[0].data.main_route;
        //     else return params.data.main_route;
        //   },
        // },
        minWidth: 130,
        //maxWidth 140,
        pinned: 'left',
      },
    ];
  }

  commonColumns() { // NOSONAR
    const columns1: { [key: string]: ColDef } = {
      route_type: {
        headerName: 'ROUTE TYPE',
        field: 'route_type',
        floatingFilterComponentParams: { suppressFilterButton: true },
        floatingFilter: true,
        filter: 'agTextColumnFilter',
        sortable: true,
        unSortIcon: true,
        minWidth: 110,
        //maxWidth 120,
        hide: false,
      },
      part_number: {
        headerName: 'PART #',
        field: 'part_number',
        floatingFilterComponentParams: { suppressFilterButton: true },
        floatingFilter: true,
        filter: 'agTextColumnFilter',
        sortable: true,
        unSortIcon: true,
        minWidth: 140,
        //maxWidth 140,
        hide: false,
        cellClass: 'orderNumbers',
        cellRenderer: OrderNumberComponent,
        cellRendererParams: { field: "part_number" },
      },
      kanban_number: {
        headerName: 'KANBAN #',
        field: 'kanban_number',
        floatingFilterComponentParams: { suppressFilterButton: true },
        floatingFilter: true,
        filter: 'agTextColumnFilter',
        sortable: true,
        unSortIcon: true,
        minWidth: 140,
        //maxWidth 140,
        hide: false,
        cellClass: 'orderNumbers',
        cellRenderer: OrderNumberComponent,
        cellRendererParams: { field: "kanban_number" },
      },
      event_type: {
        headerName: 'EVENT',
        field: 'event_type',
        floatingFilterComponentParams: { suppressFilterButton: true },
        floatingFilter: true,
        filter: 'agTextColumnFilter',
        sortable: true,
        unSortIcon: true,
        minWidth: 110,
        //maxWidth 120,
        hide: false,
        valueGetter: (params) => {
          if (params.node.group) {
            if (params.node.allLeafChildren[0].data.problem_type != null) {    // NOSONAR
              const allgroupChild = params.node.allLeafChildren.map(
                (node) => node.data.event_type
              );
              const commonValues = this.findCommonValues(allgroupChild);
              return commonValues.join(',');
            } else {
              return '';
            }
          }
          return params.data.event_type;
        },
        comparator: (a, b, _nodeA, _nodeB, isInverted) => {
          return this.customSortingForNullVal(a, b, isInverted);
        },
      },
      last_updated: {
        headerName: 'LAST UPDATE',
        field: 'last_updated',
        floatingFilterComponentParams: { suppressFilterButton: true },
        floatingFilter: true,
        filter: 'agTextColumnFilter',
        sortable: true,
        unSortIcon: true,
        minWidth: 150,
        //maxWidth 160,
        hide: false,
        comparator: (a, b, _nodeA, _nodeB, isInverted) => {
          return this.customSortingForNullVal(a, b, isInverted);
        },
      },
      transportation_provider: {
        headerName: 'LP',
        field: 'transportation_provider',
        floatingFilterComponentParams: { suppressFilterButton: true },
        floatingFilter: true,
        filter: 'agTextColumnFilter',
        sortable: true,
        unSortIcon: true,
        minWidth: 110,
        //maxWidth 120,
        hide: false,
        valueGetter: (params) => {
          if (params.node.group) {
            if (
              params.node.allLeafChildren[0].data.transportation_provider !==
              null
            ) {
              const allgroupChild = params.node.allLeafChildren.map(
                (node) => node.data.transportation_provider
              );
              const commonValues = this.findCommonValues(allgroupChild);
              return commonValues.join(',');
            } else {
              return '';
            }
          }
          return params.data.transportation_provider;
        },
        comparator: (a, b, _nodeA, _nodeB, isInverted) => {
          return this.customSortingForNullVal(a, b, isInverted);
        },
      },
      problem_type: {
        headerName: 'PROBLEM',
        field: 'problem_type',
        floatingFilterComponentParams: { suppressFilterButton: true },
        floatingFilter: true,
        filter: 'agTextColumnFilter',
        sortable: true,
        unSortIcon: true,
        minWidth: 200,
        //maxWidth 180,
        hide: false,
        valueGetter: (params) => {
          if (params.node.group) {
            if (params.node.allLeafChildren[0].data.problem_type != null) {    // NOSONAR
              const allgroupChild = params.node.allLeafChildren.map(
                (node) => node.data.problem_type
              );
              const commonValues = this.findCommonValues(allgroupChild);
              return commonValues.join(',');
            } else {
              return '';
            }
          }
          return params.data.problem_type;
        },
        comparator: (a, b, _nodeA, _nodeB, isInverted) => {
          return this.customSortingForNullVal(a, b, isInverted);
        },
      },
      region: {
        headerName: 'REGION',
        field: 'region',
        floatingFilterComponentParams: { suppressFilterButton: true },
        floatingFilter: true,
        filter: 'agTextColumnFilter',
        sortable: true,
        unSortIcon: true,
        minWidth: 80,
        //maxWidth 90,
        hide: false,
        comparator: (a, b, _nodeA, _nodeB, isInverted) => {
          return this.customSortingForNullVal(a, b, isInverted);
        },
      },
      status: {
        headerName: 'ROUTE STATUS',
        field: 'route_status',
        floatingFilterComponentParams: { suppressFilterButton: true },
        floatingFilter: true,
        filter: 'agTextColumnFilter',
        sortable: true,
        unSortIcon: true,
        minWidth: 100,
        //maxWidth 110,
        hide: false,
      },
      eta: {
        headerName: 'ETA',
        field: 'eta',
        floatingFilterComponentParams: { suppressFilterButton: true },
        floatingFilter: true,
        filter: 'agTextColumnFilter',
        sortable: true,
        unSortIcon: true,
        minWidth: 150,
        //maxWidth 160,
        hide: false,
        comparator: (a, b, _nodeA, _nodeB, isInverted) => {
          return this.customSortingForNullVal(a, b, isInverted);
        },
      },
      event_trailer: {
        headerName: 'TRAILER',
        field: 'event_trailer',
        floatingFilterComponentParams: { suppressFilterButton: true },
        floatingFilter: true,
        filter: 'agTextColumnFilter',
        sortable: true,
        unSortIcon: true,
        minWidth: 100,
        //maxWidth 110,
        hide: false,
        comparator: (a, b, _nodeA, _nodeB, isInverted) => {
          return this.customSortingForNullVal(a, b, isInverted);
        },
      },
      next_connection: {
        headerName: 'NEXT CONNECTION',
        field: 'next_connection',
        floatingFilterComponentParams: { suppressFilterButton: true },
        floatingFilter: true,
        filter: 'agTextColumnFilter',
        sortable: true,
        unSortIcon: true,
        minWidth: 150,
        //maxWidth 160,
        hide: false,
        comparator: (a, b, _nodeA, _nodeB, isInverted) => {
          return this.customSortingForNullVal(a, b, isInverted);
        },
      },
      comments: {
        headerName: 'COMMENTS',
        field: 'comments',
        floatingFilterComponentParams: { suppressFilterButton: true },
        floatingFilter: true,
        filter: 'agTextColumnFilter',
        sortable: true,
        unSortIcon: true,
        minWidth: 150,
        //maxWidth 160,
        hide: false,
        wrapText: false,
        autoHeight: false,
        cellRenderer: EventCommentRendererComponent,
        tooltipComponent: DashCommentTooltip,
        tooltipField: 'comments',
        comparator: (a, b, _nodeA, _nodeB, isInverted) => {
          return this.customSortingForNullVal(a, b, isInverted);
        },
      },
      order_number: {
        headerName: 'ORDER #',
        field: 'order_number',
        floatingFilterComponentParams: { suppressFilterButton: true },
        floatingFilter: true,
        filter: 'agTextColumnFilter',
        sortable: true,
        unSortIcon: true,
        minWidth: 140,
        //maxWidth 140,
        hide: false,
        cellClass: 'orderNumbers',
        cellRenderer: OrderNumberComponent,
        cellRendererParams: { field: "order_number" },
      },
      border_crossing: {
        headerName: 'BORDER CROSSING',
        field: 'border',
        floatingFilterComponentParams: { suppressFilterButton: true },
        floatingFilter: false,
        sortable: true,
        unSortIcon: true,
        minWidth: 100,
        hide: false,
        cellRenderer: BorderCrossing,
        cellStyle: { 'justify-content': 'center' },
        comparator: (a, b, _nodeA, _nodeB, isInverted) => {
          return this.customSortingBorderCrossing(a, b, isInverted);
        },
      },
    };

    return columns1
  }

  remainingcolumn() { // NOSONAR
    const remainicol = [
      {
        headerName: 'DISPATCH',
        field: 'dispatch_end_date',
        floatingFilterComponentParams: { suppressFilterButton: true },
        floatingFilter: true,
        filter: 'agTextColumnFilter',
        sortable: true,
        unSortIcon: true,
        tooltipField: 'dispatch_name',
        tooltipComponentParams: { field: 'dispatch' },
        minWidth: 150,
        //maxWidth 160,
        valueGetter: (params: any) => {
          if (params.node.group) {
            return params.node.childrenAfterFilter[0].data.dispatch_end_date
              ? params.node.childrenAfterFilter[0].data.dispatch_end_date
              : '';
          }
          return params.data?.dispatch_end_date;
        },
        comparator: (a, b, _nodeA, _nodeB, isInverted) => {
          return this.customSortingForNullVal(a, b, isInverted);
        },
      },
      {
        headerName: 'P/U 1',
        field: 'stop_1_name',
        floatingFilterComponentParams: { suppressFilterButton: true },
        floatingFilter: false,
        sortable: true,
        unSortIcon: true,
        tooltipField: 'stop_1_name',
        tooltipComponentParams: { field: 'pu1' },
        minWidth: 70,
        //maxWidth 80,
        cellStyle: function (params: CellClassParams) {  // NOSONAR
          let cellChangeValue1;
          if ( params.data?.stop_1_nacode == undefined || params.data?.stop_1_nacode == null ) {  // NOSONAR
            return {};
          }

          if ( params.data?.stop_1_actual == undefined || params.data?.stop_1_actual == null ) {  // NOSONAR
            if ( params.data?.stop_1_eta == undefined || params.data?.stop_1_eta == null ) {  // NOSONAR
              cellChangeValue1 = params.data?.cellChange(
                params.data?.stop_1_parts_reload_end,
                params.data?.currentDate,
                params.data?.yellowTrigger,
                params.data?.redTrigger
              );
              if (cellChangeValue1 == 'lightgreen') {  // NOSONAR
                return { color: 'black', backgroundColor: 'lightgreen' };
              } else if (cellChangeValue1 == 'yellow') {  // NOSONAR
                return { color: 'white', backgroundColor: 'grey' };
              } else {
                return { color: 'white', backgroundColor: 'grey' };
              }
            } else {
              cellChangeValue1 = params.data?.cellChange(
                params.data?.stop_1_parts_reload_end,
                params.data?.stop_1_eta,
                params.data?.yellowTrigger,
                params.data?.redTrigger
              );
              if (cellChangeValue1 == 'lightgreen') {  // NOSONAR
                return { color: 'black', backgroundColor: 'lightgreen' };
              } else if (cellChangeValue1 == 'yellow') {  // NOSONAR
                return { color: 'black', backgroundColor: 'amber' };
              } else {
                return { color: 'black', backgroundColor: 'amber' };
              }
            }
          } else {
            cellChangeValue1 = params.data?.cellChange(
              params.data?.stop_1_parts_reload_end,
              params.data?.stop_1_actual,
              params.data?.yellowTrigger,
              params.data?.redTrigger
            );
            if (cellChangeValue1 == 'lightgreen') {  // NOSONAR
              return { color: 'black', backgroundColor: 'lightgreen' };
            } else if (cellChangeValue1 == 'yellow') {  // NOSONAR
              return { color: 'black', backgroundColor: 'yellow' };
            } else {
              return { color: 'white', backgroundColor: 'red' };
            }
          }
        },
        valueGetter: (params) => {
          if (params.node.group) {
            return params.node.childrenAfterFilter[0].data.stop_1_name;
          }
          return params.data?.stop_1_name;
        },
        comparator: (a, b, _nodeA, _nodeB, isInverted) => {
          return this.customSortingForNullVal(a, b, isInverted);
        },
      },
      {
        headerName: 'P/U 2',
        field: 'stop_2_name',
        floatingFilterComponentParams: { suppressFilterButton: true },
        floatingFilter: false,
        sortable: true,
        unSortIcon: true,
        tooltipField: 'stop_2_name',
        tooltipComponentParams: { field: 'pu2' },
        minWidth: 70,
        //maxWidth 80,
        cellStyle: function (params: CellClassParams) {  // NOSONAR
          let cellChangeValue2;
          if ( params.data?.stop_2_nacode == undefined || params.data?.stop_2_nacode == null ) {  // NOSONAR
            return {};
          }

          if ( params.data?.stop_2_actual == undefined || params.data?.stop_2_actual == null ) {  // NOSONAR
            if ( params.data?.stop_2_eta == undefined || params.data?.stop_2_eta == null ) {  // NOSONAR
              cellChangeValue2 = params.data?.cellChange(
                params.data?.stop_2_parts_reload_end,
                params.data?.currentDate,
                params.data?.yellowTrigger,
                params.data?.redTrigger
              );
              if (cellChangeValue2 == 'lightgreen') {  // NOSONAR
                return { color: 'black', backgroundColor: 'lightgreen' };
              } else if (cellChangeValue2 == 'yellow') {  // NOSONAR
                return { color: 'white', backgroundColor: 'grey' };
              } else {
                return { color: 'white', backgroundColor: 'grey' };
              }
            } else {
              cellChangeValue2 = params.data?.cellChange(
                params.data?.stop_2_parts_reload_end,
                params.data?.stop_2_eta,
                params.data?.yellowTrigger,
                params.data?.redTrigger
              );
              if (cellChangeValue2 == 'lightgreen') {  // NOSONAR
                return { color: 'black', backgroundColor: 'lightgreen' };
              } else if (cellChangeValue2 == 'yellow') {  // NOSONAR
                return { color: 'black', backgroundColor: 'amber' };
              } else {
                return { color: 'black', backgroundColor: 'amber' };
              }
            }
          } else {
            cellChangeValue2 = params.data?.cellChange(
              params.data?.stop_2_parts_reload_end,
              params.data?.stop_2_actual,
              params.data?.yellowTrigger,
              params.data?.redTrigger
            );
            if (cellChangeValue2 == 'lightgreen') {   // NOSONAR
              return { color: 'black', backgroundColor: 'lightgreen' };
            } else if (cellChangeValue2 == 'yellow') {   // NOSONAR
              return { color: 'black', backgroundColor: 'yellow' };
            } else {
              return { color: 'white', backgroundColor: 'red' };
            }
          }
        },
        valueGetter: (params) => {
          if (params.node.group) {
            return params.node.childrenAfterFilter[0].data.stop_2_name;
          }
          return params.data?.stop_2_name;
        },
        comparator: (a, b, _nodeA, _nodeB, isInverted) => {
          return this.customSortingForNullVal(a, b, isInverted);
        },
      },
      {
        headerName: 'P/U 3',
        field: 'stop_3_name',
        floatingFilterComponentParams: { suppressFilterButton: true },
        floatingFilter: false,
        sortable: true,
        unSortIcon: true,
        tooltipField: 'stop_3_name',
        tooltipComponentParams: { field: 'pu3' },
        minWidth: 70,
        //maxWidth 80,
        cellStyle: function (params: CellClassParams) {  // NOSONAR
          let cellChangeValue3;
          if ( params.data?.stop_3_nacode == undefined || params.data?.stop_3_nacode == null ) {  // NOSONAR
            return {};
          }

          if ( params.data?.stop_3_actual == undefined || params.data?.stop_3_actual == null ) {  // NOSONAR
            if ( params.data?.stop_3_eta == undefined || params.data?.stop_3_eta == null ) {  // NOSONAR
              cellChangeValue3 = params.data?.cellChange(
                params.data?.stop_3_parts_reload_end,
                params.data?.currentDate,
                params.data?.yellowTrigger,
                params.data?.redTrigger
              );
              if (cellChangeValue3 == 'lightgreen') {  // NOSONAR
                return { color: 'black', backgroundColor: 'lightgreen' };
              } else if (cellChangeValue3 == 'yellow') {  // NOSONAR
                return { color: 'white', backgroundColor: 'grey' };
              } else {
                return { color: 'white', backgroundColor: 'grey' };
              }
            } else {
              cellChangeValue3 = params.data?.cellChange(
                params.data?.stop_3_parts_reload_end,
                params.data?.stop_3_eta,
                params.data?.yellowTrigger,
                params.data?.redTrigger
              );
              if (cellChangeValue3 == 'lightgreen') {  // NOSONAR
                return { color: 'black', backgroundColor: 'lightgreen' };
              } else if (cellChangeValue3 == 'yellow') {  // NOSONAR
                return { color: 'black', backgroundColor: 'amber' };
              } else {
                return { color: 'black', backgroundColor: 'amber' };
              }
            }
          } else {
            cellChangeValue3 = params.data?.cellChange(
              params.data?.stop_3_parts_reload_end,
              params.data?.stop_3_actual,
              params.data?.yellowTrigger,
              params.data?.redTrigger
            );
            if (cellChangeValue3 == 'lightgreen') {  // NOSONAR
              return { color: 'black', backgroundColor: 'lightgreen' };
            } else if (cellChangeValue3 == 'yellow') {  // NOSONAR
              return { color: 'black', backgroundColor: 'yellow' };
            } else {
              return { color: 'white', backgroundColor: 'red' };
            }
          }
        },
        valueGetter: (params) => {
          if (params.node.group) {
            return params.node.childrenAfterFilter[0].data.stop_3_name;
          }
          return params.data?.stop_3_name;
        },
        comparator: (a, b, _nodeA, _nodeB, isInverted) => {
          return this.customSortingForNullVal(a, b, isInverted);
        },
      },
      {
        headerName: 'P/U 4',
        field: 'stop_4_name',
        floatingFilterComponentParams: { suppressFilterButton: true },
        floatingFilter: false,
        sortable: true,
        unSortIcon: true,
        tooltipField: 'stop_4_name',
        tooltipComponentParams: { field: 'pu4' },
        minWidth: 70,
        //maxWidth 80,
        cellStyle: function (params: CellClassParams) {  // NOSONAR
          let cellChangeValue4;
          if ( params.data?.stop_4_nacode == undefined || params.data?.stop_4_nacode == null ) {  // NOSONAR
            return {};
          }

          if ( params.data?.stop_4_actual == undefined || params.data?.stop_4_actual == null ) {  // NOSONAR
            if ( params.data?.stop_4_eta == undefined || params.data?.stop_4_eta == null ) {  // NOSONAR
              cellChangeValue4 = params.data?.cellChange(
                params.data?.stop_4_parts_reload_end,
                params.data?.currentDate,
                params.data?.yellowTrigger,
                params.data?.redTrigger
              );
              if (cellChangeValue4 == 'lightgreen') {  // NOSONAR
                return { color: 'black', backgroundColor: 'lightgreen' };
              } else if (cellChangeValue4 == 'yellow') {  // NOSONAR
                return { color: 'white', backgroundColor: 'grey' };
              } else {
                return { color: 'white', backgroundColor: 'grey' };
              }
            } else {
              cellChangeValue4 = params.data?.cellChange(
                params.data?.stop_4_parts_reload_end,
                params.data?.stop_4_eta,
                params.data?.yellowTrigger,
                params.data?.redTrigger
              );
              if (cellChangeValue4 == 'lightgreen') {  // NOSONAR
                return { color: 'black', backgroundColor: 'lightgreen' };
              } else if (cellChangeValue4 == 'yellow') {  // NOSONAR
                return { color: 'black', backgroundColor: 'amber' };
              } else {
                return { color: 'black', backgroundColor: 'amber' };
              }
            }
          } else {
            cellChangeValue4 = params.data?.cellChange(
              params.data?.stop_4_parts_reload_end,
              params.data?.stop_4_actual,
              params.data?.yellowTrigger,
              params.data?.redTrigger
            );
            if (cellChangeValue4 == 'lightgreen') {  // NOSONAR
              return { color: 'black', backgroundColor: 'lightgreen' };
            } else if (cellChangeValue4 == 'yellow') {  // NOSONAR
              return { color: 'black', backgroundColor: 'yellow' };
            } else {
              return { color: 'white', backgroundColor: 'red' };
            }
          }
        },
        valueGetter: (params) => {
          if (params.node.group) {
            return params.node.childrenAfterFilter[0].data.stop_4_name;
          }
          return params.data?.stop_4_name;
        },
        comparator: (a, b, _nodeA, _nodeB, isInverted) => {
          return this.customSortingForNullVal(a, b, isInverted);
        },
      },
      {
        headerName: 'P/U 5',
        field: 'stop_5_name',
        floatingFilterComponentParams: { suppressFilterButton: true },
        floatingFilter: false,
        sortable: true,
        unSortIcon: true,
        tooltipField: 'stop_5_name',
        tooltipComponentParams: { field: 'pu5' },
        minWidth: 70,
        //maxWidth 80,
        cellStyle: function (params: CellClassParams) {    // NOSONAR
          let cellChangeValue5;
          if ( params.data?.stop_5_nacode == undefined || params.data?.stop_5_nacode == null ) {  // NOSONAR
            return {};
          }

          if ( params.data?.stop_5_actual == undefined || params.data?.stop_5_actual == null ) {  // NOSONAR
            if ( params.data?.stop_5_eta == undefined || params.data?.stop_5_eta == null ) {  // NOSONAR
              cellChangeValue5 = params.data?.cellChange(
                params.data?.stop_5_parts_reload_end,
                params.data?.currentDate,
                params.data?.yellowTrigger,
                params.data?.redTrigger
              );
              if (cellChangeValue5 == 'lightgreen') {  // NOSONAR
                return { color: 'black', backgroundColor: 'lightgreen' };
              } else if (cellChangeValue5 === 'yellow') {
                return { color: 'white', backgroundColor: 'grey' };
              } else {
                return { color: 'white', backgroundColor: 'grey' };
              }
            } else {
              cellChangeValue5 = params.data?.cellChange(
                params.data?.stop_5_parts_reload_end,
                params.data?.stop_5_eta,
                params.data?.yellowTrigger,
                params.data?.redTrigger
              );
              if (cellChangeValue5 == 'lightgreen') {  // NOSONAR
                return { color: 'black', backgroundColor: 'lightgreen' };
              } else if (cellChangeValue5 == 'yellow') {  // NOSONAR
                return { color: 'black', backgroundColor: 'amber' };
              } else {
                return { color: 'black', backgroundColor: 'amber' };
              }
            }
          } else {
            cellChangeValue5 = params.data?.cellChange(
              params.data?.stop_5_parts_reload_end,
              params.data?.stop_5_actual,
              params.data?.yellowTrigger,
              params.data?.redTrigger
            );
            if (cellChangeValue5 == 'lightgreen') {  // NOSONAR
              return { color: 'black', backgroundColor: 'lightgreen' };
            } else if (cellChangeValue5 == 'yellow') {  // NOSONAR
              return { color: 'black', backgroundColor: 'yellow' };
            } else {
              return { color: 'white', backgroundColor: 'red' };
            }
          }
        },
        valueGetter: (params) => {
          if (params.node.group) {
            return params.node.childrenAfterFilter[0].data.stop_5_name;
          }
          return params.data?.stop_5_name;
        },
        comparator: (a, b, _nodeA, _nodeB, isInverted) => {
          return this.customSortingForNullVal(a, b, isInverted);
        },
      },
      {
        headerName: 'P/U 6',
        field: 'stop_6_name',
        floatingFilterComponentParams: { suppressFilterButton: true },
        floatingFilter: false,
        sortable: true,
        unSortIcon: true,
        tooltipField: 'stop_6_name',
        tooltipComponentParams: { field: 'pu6' },
        minWidth: 70,
        //maxWidth 80,
        cellStyle: function (params: CellClassParams) {  // NOSONAR
          let cellChangeValue6;
          if ( params.data?.stop_6_nacode == undefined || params.data?.stop_6_nacode == null ) {  // NOSONAR
            return {};
          }

          if ( params.data?.stop_6_actual == undefined || params.data?.stop_6_actual == null ) {  // NOSONAR
            if ( params.data?.stop_6_eta == undefined || params.data?.stop_6_eta == null ) {  // NOSONAR
              cellChangeValue6 = params.data?.cellChange(
                params.data?.stop_6_parts_reload_end,
                params.data?.currentDate,
                params.data?.yellowTrigger,
                params.data?.redTrigger
              );
              if (cellChangeValue6 == 'lightgreen') { // NOSONAR
                return { color: 'black', backgroundColor: 'lightgreen' };
              } else if (cellChangeValue6 == 'yellow') { // NOSONAR
                return { color: 'white', backgroundColor: 'grey' };
              } else {
                return { color: 'white', backgroundColor: 'grey' };
              }
            } else {
              cellChangeValue6 = params.data?.cellChange(
                params.data?.stop_6_parts_reload_end,
                params.data?.stop_6_eta,
                params.data?.yellowTrigger,
                params.data?.redTrigger
              );
              if (cellChangeValue6 == 'lightgreen') { // NOSONAR
                return { color: 'black', backgroundColor: 'lightgreen' };
              } else if (cellChangeValue6 == 'yellow') { // NOSONAR
                return { color: 'black', backgroundColor: 'amber' };
              } else {
                return { color: 'black', backgroundColor: 'amber' };
              }
            }
          } else {
            cellChangeValue6 = params.data?.cellChange(
              params.data?.stop_6_parts_reload_end,
              params.data?.stop_6_actual,
              params.data?.yellowTrigger,
              params.data?.redTrigger
            );
            if (cellChangeValue6 == 'lightgreen') { // NOSONAR
              return { color: 'black', backgroundColor: 'lightgreen' };
            } else if (cellChangeValue6 == 'yellow') { // NOSONAR
              return { color: 'black', backgroundColor: 'yellow' };
            } else {
              return { color: 'white', backgroundColor: 'red' };
            }
          }
        },
        comparator: (a, b, _nodeA, _nodeB, isInverted) => {
          return this.customSortingForNullVal(a, b, isInverted);
        },
      },
      {
        headerName: 'P/U 7',
        field: 'stop_7_name',
        floatingFilterComponentParams: { suppressFilterButton: true },
        floatingFilter: false,
        sortable: true,
        unSortIcon: true,
        tooltipField: 'stop_7_name',
        tooltipComponentParams: { field: 'pu7' },
        minWidth: 70,
        //maxWidth 80,
        cellStyle: function (params: CellClassParams) {  // NOSONAR
          let cellChangeValue7;
          if ( params.data?.stop_7_nacode == undefined || params.data?.stop_7_nacode == null ) {  // NOSONAR
            return {};
          }

          if ( params.data?.stop_7_actual == undefined || params.data?.stop_7_actual == null ) { // NOSONAR
            if ( params.data?.stop_7_eta == undefined || params.data?.stop_7_eta == null ) { // NOSONAR
              cellChangeValue7 = params.data?.cellChange(
                params.data?.stop_7_parts_reload_end,
                params.data?.currentDate,
                params.data?.yellowTrigger,
                params.data?.redTrigger
              );
              if (cellChangeValue7 == 'lightgreen') { // NOSONAR
                return { color: 'black', backgroundColor: 'lightgreen' };
              } else if (cellChangeValue7 == 'yellow') {  // NOSONAR
                return { color: 'white', backgroundColor: 'grey' };
              } else {
                return { color: 'white', backgroundColor: 'grey' };
              }
            } else {
              cellChangeValue7 = params.data?.cellChange(
                params.data?.stop_7_parts_reload_end,
                params.data?.stop_7_eta,
                params.data?.yellowTrigger,
                params.data?.redTrigger
              );
              if (cellChangeValue7 == 'lightgreen') {  // NOSONAR
                return { color: 'black', backgroundColor: 'lightgreen' };
              } else if (cellChangeValue7 == 'yellow') {  // NOSONAR
                return { color: 'black', backgroundColor: 'amber' };
              } else {
                return { color: 'black', backgroundColor: 'amber' };
              }
            }
          } else {
            cellChangeValue7 = params.data?.cellChange(
              params.data?.stop_7_parts_reload_end,
              params.data?.stop_7_actual,
              params.data?.yellowTrigger,
              params.data?.redTrigger
            );
            if (cellChangeValue7 == 'lightgreen') {  // NOSONAR
              return { color: 'black', backgroundColor: 'lightgreen' };
            } else if (cellChangeValue7 == 'yellow') {  // NOSONAR
              return { color: 'black', backgroundColor: 'yellow' };
            } else {
              return { color: 'white', backgroundColor: 'red' };
            }
          }
        },
        comparator: (a, b, _nodeA, _nodeB, isInverted) => {
          return this.customSortingForNullVal(a, b, isInverted);
        },
      },
      {
        headerName: 'P/U 8',
        field: 'stop_8_name',
        floatingFilterComponentParams: { suppressFilterButton: true },
        floatingFilter: false,
        sortable: true,
        unSortIcon: true,
        tooltipField: 'stop_8_name',
        tooltipComponentParams: { field: 'pu8' },
        minWidth: 70,
        //maxWidth 80,
        cellStyle: function (params: CellClassParams) {  // NOSONAR
          let cellChangeValue8;
          if ( params.data?.stop_8_nacode == undefined || params.data?.stop_8_nacode == null ) {  // NOSONAR
            return {};
          }

          if ( params.data?.stop_8_actual == undefined || params.data?.stop_8_actual == null ) {  // NOSONAR
            if ( params.data?.stop_8_eta == undefined || params.data?.stop_8_eta == null ) {  // NOSONAR
              cellChangeValue8 = params.data?.cellChange(
                params.data?.stop_8_parts_reload_end,
                params.data?.currentDate,
                params.data?.yellowTrigger,
                params.data?.redTrigger
              );
              if (cellChangeValue8 == 'lightgreen') { // NOSONAR
                return { color: 'black', backgroundColor: 'lightgreen' };
              } else if (cellChangeValue8 == 'yellow') {  // NOSONAR
                return { color: 'white', backgroundColor: 'grey' };
              } else {
                return { color: 'white', backgroundColor: 'grey' };
              }
            } else {
              cellChangeValue8 = params.data?.cellChange(
                params.data?.stop_8_parts_reload_end,
                params.data?.stop_8_eta,
                params.data?.yellowTrigger,
                params.data?.redTrigger
              );
              if (cellChangeValue8 == 'lightgreen') {                          // NOSONAR
                return { color: 'black', backgroundColor: 'lightgreen' };
              } else if (cellChangeValue8 == 'yellow') {                         // NOSONAR
                return { color: 'black', backgroundColor: 'amber' };
              } else {
                return { color: 'black', backgroundColor: 'amber' };
              }
            }
          } else {
            cellChangeValue8 = params.data?.cellChange(
              params.data?.stop_8_parts_reload_end,
              params.data?.stop_8_actual,
              params.data?.yellowTrigger,
              params.data?.redTrigger
            );
            if (cellChangeValue8 == 'lightgreen') {                         // NOSONAR
              return { color: 'black', backgroundColor: 'lightgreen' };
            } else if (cellChangeValue8 == 'yellow') {                         // NOSONAR
              return { color: 'black', backgroundColor: 'yellow' };
            } else {
              return { color: 'white', backgroundColor: 'red' };
            }
          }
        },
        comparator: (a, b, _nodeA, _nodeB, isInverted) => {
          return this.customSortingForNullVal(a, b, isInverted);
        },
      },
      {
        headerName: 'P/U 9',
        field: 'stop_9_name',
        floatingFilterComponentParams: { suppressFilterButton: true },
        floatingFilter: false,
        sortable: true,
        unSortIcon: true,
        tooltipField: 'stop_9_name',
        tooltipComponentParams: { field: 'pu9' },
        minWidth: 70,
        //maxWidth 80,
        cellStyle: function (params: CellClassParams) { // NOSONAR
          let cellChangeValue9;
          if ( params.data?.stop_9_nacode == undefined || params.data?.stop_9_nacode == null ) {                         // NOSONAR
            return {};
          }

          if ( params.data?.stop_9_actual == undefined || params.data?.stop_9_actual == null ) {                         // NOSONAR
            if ( params.data?.stop_9_eta == undefined || params.data?.stop_9_eta == null ) {                         // NOSONAR
              cellChangeValue9 = params.data?.cellChange(
                params.data?.stop_9_parts_reload_end,
                params.data?.currentDate,
                params.data?.yellowTrigger,
                params.data?.redTrigger
              );
              if (cellChangeValue9 == 'lightgreen') {                         // NOSONAR
                return { color: 'black', backgroundColor: 'lightgreen' };
              } else if (cellChangeValue9 == 'yellow') {                         // NOSONAR
                return { color: 'white', backgroundColor: 'grey' };
              } else {
                return { color: 'white', backgroundColor: 'grey' };
              }
            } else {
              cellChangeValue9 = params.data?.cellChange(
                params.data?.stop_9_parts_reload_end,
                params.data?.stop_9_eta,
                params.data?.yellowTrigger,
                params.data?.redTrigger
              );
              if (cellChangeValue9 == 'lightgreen') {                         // NOSONAR
                return { color: 'black', backgroundColor: 'lightgreen' };
              } else if (cellChangeValue9 == 'yellow') {                         // NOSONAR
                return { color: 'black', backgroundColor: 'amber' };
              } else {
                return { color: 'black', backgroundColor: 'amber' };
              }
            }
          } else {
            cellChangeValue9 = params.data?.cellChange(
              params.data?.stop_9_parts_reload_end,
              params.data?.stop_9_actual,
              params.data?.yellowTrigger,
              params.data?.redTrigger
            );
            if (cellChangeValue9 == 'lightgreen') {                         // NOSONAR
              return { color: 'black', backgroundColor: 'lightgreen' };
            } else if (cellChangeValue9 == 'yellow') {                         // NOSONAR
              return { color: 'black', backgroundColor: 'yellow' };
            } else {
              return { color: 'white', backgroundColor: 'red' };
            }
          }
        },
        comparator: (a, b, _nodeA, _nodeB, isInverted) => {
          return this.customSortingForNullVal(a, b, isInverted);
        },
      },
      {
        headerName: 'P/U 10',
        field: 'stop_10_name',
        floatingFilterComponentParams: { suppressFilterButton: true },
        floatingFilter: false,
        sortable: true,
        unSortIcon: true,
        tooltipField: 'stop_10_name',
        tooltipComponentParams: { field: 'pu10' },
        minWidth: 70,
        //maxWidth 80,
        cellStyle: function (params: CellClassParams) { // NOSONAR
          let cellChangeValue10;
          if ( params.data?.stop_10_nacode == undefined || params.data?.stop_10_nacode == null ) {                         // NOSONAR
            return {};
          }

          if ( params.data?.stop_10_actual == undefined || params.data?.stop_10_actual == null ) {                         // NOSONAR
            if ( params.data?.stop_10_eta == undefined || params.data?.stop_10_eta == null ) {                         // NOSONAR
              cellChangeValue10 = params.data?.cellChange(
                params.data?.stop_10_parts_reload_end,
                params.data?.currentDate,
                params.data?.yellowTrigger,
                params.data?.redTrigger
              );
              if (cellChangeValue10 == 'lightgreen') {                          // NOSONAR
                return { color: 'black', backgroundColor: 'lightgreen' };
              } else if (cellChangeValue10 == 'yellow') {                         // NOSONAR
                return { color: 'white', backgroundColor: 'grey' };
              } else {
                return { color: 'white', backgroundColor: 'grey' };
              }
            } else {
              cellChangeValue10 = params.data?.cellChange(
                params.data?.stop_10_parts_reload_end,
                params.data?.stop_10_eta,
                params.data?.yellowTrigger,
                params.data?.redTrigger
              );
              if (cellChangeValue10 == 'lightgreen') {                         // NOSONAR
                return { color: 'black', backgroundColor: 'lightgreen' };
              } else if (cellChangeValue10 == 'yellow') {                         // NOSONAR
                return { color: 'black', backgroundColor: 'amber' };
              } else {
                return { color: 'black', backgroundColor: 'amber' };
              }
            }
          } else {
            cellChangeValue10 = params.data?.cellChange(
              params.data?.stop_10_parts_reload_end,
              params.data?.stop_10_actual,
              params.data?.yellowTrigger,
              params.data?.redTrigger
            );
            if (cellChangeValue10 == 'lightgreen') {                         // NOSONAR
              return { color: 'black', backgroundColor: 'lightgreen' };
            } else if (cellChangeValue10 == 'yellow') {                         // NOSONAR
              return { color: 'black', backgroundColor: 'yellow' };
            } else {
              return { color: 'white', backgroundColor: 'red' };
            }
          }
        },
        comparator: (a, b, _nodeA, _nodeB, isInverted) => {
          return this.customSortingForNullVal(a, b, isInverted);
        },
      },
    ];

    return remainicol
  }
  openBorderCrossing(routeId: number, mainRoute: string, unload: string) {
    const dialogRef = this.dialog.open(BorderCrossingComponent, {
      disableClose: true,
      width: '1010px',
      height: '413px',
      panelClass: 'border-crossing-panel',
      data: {
        routeId: routeId,
        mainRoute: mainRoute,
        unload: unload,
        timeZone: this.selectedTimeZone,
        isDST: this.isDSTChecked,
      },
    });
    console.info(dialogRef)
  }

  findCommonValues(arr) {
    const counts = {};
    for (const item of arr) {
      counts[item] = counts[item] ? counts[item] + 1 : 1;
    }
    // console.info('counts[item]..',counts)
    return Object.keys(counts).filter((item) => counts[item] == 1);                          // NOSONAR
  }
  cellChange(paramsDate, actualDate, yellowTrigger, redTrigger) {
    if (
      -1 * (Date.parse(paramsDate) - Date.parse(actualDate)) <
      yellowTrigger * 60 * 1000
    ) {
      return 'lightgreen';
    } else if (
      -1 * (Date.parse(paramsDate) - Date.parse(actualDate)) <
      redTrigger * 60 * 1000
    ) {
      return 'yellow';
    } else {
      return 'red';
    }
  }

  statusWrap(item, yellowTrigger, redTrigger) {
    if (item.route_status != null) {     // NOSONAR
      return item.route_status;
    }
    if (item.yard_arrival_actual != null && item.yard_arrival_actual != '') {   // NOSONAR
      return this.const_arr;
    }
    const statusStore = this.statusChange(item, yellowTrigger, redTrigger);
    if (statusStore == 'Late') {                         // NOSONAR
      return statusStore;
    } else {
      const currDate = new Date().getTime();
      const dispatchDate = new Date(
        item.route_type == 'LTL'                         // NOSONAR
          ? item.stop_1_parts_reload_start
          : item.dispatch_end_date
      ).getTime();
      if (currDate > dispatchDate) {
        return this.const_inprg;
      } else {
        return this.const_not_started;
      }
    }
  }
  statusChange(item, yellowTrigger, redTrigger) {
    const stops = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

    for (const i of stops) {
      const cellValue = this.statusChangeStop(
        item[`stop_${i}_parts_reload_end`],
        item[`stop_${i}_actual`],
        yellowTrigger,
        redTrigger
      );

      if (!cellValue && item[`stop_${i}_nacode`] != null) {     // NOSONAR
        return 'Late';
      }
    }

    return 'No Delay';
  }


  statusChangeStop(reloadEnd, actual, yellowTrigger, redTrigger) {
    let cellChangeValue1;
    if (actual == undefined || actual == null) {  // NOSONAR
      cellChangeValue1 = this.cellChange(
        reloadEnd?.substring(0, 16),
        this.getTimezone(),
        yellowTrigger,
        redTrigger
      );
      if (cellChangeValue1 == 'lightgreen') {                         // NOSONAR
        return true;
      } else {
        return false;
      }
    } else {
      cellChangeValue1 = this.cellChange(
        reloadEnd?.substring(0, 16),
        actual.substring(0, 16),
        yellowTrigger,
        redTrigger
      );
      if (cellChangeValue1 == 'lightgreen') {                         // NOSONAR
        return true;
      } else {
        return false;
      }
    }
  }

  settingsDataMap() {
    this.service.loadMasterSettingsOfDomicile().subscribe(
      (response: any) => {
        console.info('Response', response);
        this.masterSettingResponse = response;
      },
      (_error) => {
        this.showError(this.getApiErrorMessage(_error));
      }
    );
  }

  exportDashboardData() {
    const headers = ['ROUTE ID', 'ROUTE', 'REGION', 'LP', 'EVENT', 'PROBLEM', 'TRAILER', 'ORDER #', 'PART #', 'ETA', 'EVENT STATUS', 'ROUTE STATUS', 'NEXT CONNECTION', 'LAST UPDATE', 'ROUTE TYPE', 'DISPATCH NAME', 'DISPATCH NA CODE', 'DISPATCH CA CODE', 'DISPATCH MTM CODE', 'DISPATCH START', 'DISPATCH END', 'P/U 1 NAME', 'P/U 1 NA CODE', 'P/U 1 CA CODE', 'P/U 1 MTM CODE', this.const_plnd_start, this.const_planned, this.const_scanned, 'P/U 2 NAME', 'P/U 2 NA CODE', 'P/U 2 CA CODE', 'P/U 2 MTM CODE', this.const_plnd_start, this.const_planned, this.const_scanned, 'P/U 3 NAME', 'P/U 3 NA CODE', 'P/U 3 CA CODE', 'P/U 3 MTM CODE', this.const_plnd_start, this.const_planned, this.const_scanned, 'P/U 4 NAME', 'P/U 4 NA CODE', 'P/U 4 CA CODE', 'P/U 4 MTM CODE', this.const_plnd_start, this.const_planned, this.const_scanned, 'P/U 5 NAME', 'P/U 5 NA CODE', 'P/U 5 CA CODE', 'P/U 5 MTM CODE', this.const_plnd_start, this.const_planned, this.const_scanned, 'P/U 6 NAME', 'P/U 6 NA CODE', 'P/U 6 CA CODE', 'P/U 6 MTM CODE', this.const_plnd_start, this.const_planned, this.const_scanned, 'P/U 7 NAME', 'P/U 7 NA CODE', 'P/U 7 CA CODE', 'P/U 7 MTM CODE', this.const_plnd_start, this.const_planned, this.const_scanned, 'P/U 8 NAME', 'P/U 8 NA CODE', 'P/U 8 CA CODE', 'P/U 8 MTM CODE', this.const_plnd_start, this.const_planned, this.const_scanned, 'P/U 9 NAME', 'P/U 9 NA CODE', 'P/U 9 CA CODE', 'P/U 9 MTM CODE', this.const_plnd_start, this.const_planned, this.const_scanned, 'P/U 10 NAME', 'P/U 10 NA CODE', 'P/U 10 CA CODE', 'P/U 10 MTM CODE', this.const_plnd_start, this.const_planned, this.const_scanned, 'YARD NAME', 'YARD NA CODE', 'YARD CA CODE', 'YARD MTM CODE', 'YARD ARRIVAL START', 'YARD ARRIVAL END', this.const_scanned, 'UNLOAD START', 'UNLOAD END', this.const_scanned,];
    const exportData = [];
    this.displayRowData.forEach((e) => {
      const obj = {
        ROUTE_ID: e.route_id,
        ROUTE: e.main_route,
        REGION: e.region,
        LP: e.transportation_provider,
        EVENT: e.event_type,
        PROBLEM: e.problem_type,
        TRAILER: e.event_trailer,
        ORDER: e.order_number,
        PART: e.part_number,
        ETA: e.eta,
        EVENT_STATUS: e.status,
        ROUTE_STATUS: e.route_status,
        NEXT_CONNECTION: e.next_connection,
        LAST_UPDATE: e.last_updated,
        ROUTE_TYPE: e.route_type,
        DISPATCH: e.dispatch_name,
        DISPATCH_NACODE: e.dispatch_nacode,
        DISPATCH_CACODE: e.dispatch_cacode,
        DISPATCH_MTMCODE: e.dispatch_mtmcode,
        DISPATCH_START: e.dispatch_start_date,
        DISPATCH_END: e.dispatch_end_date,
        PU_1: e.stop_1_name,
        PU_1_NACODE: e.stop_1_nacode,
        PU_1_CACODE: e.stop_1_cacode,
        PU_1_MTMCODE: e.stop_1_mtmcode,
        PLANNED_RELOAD_START_1: e.stop_1_parts_reload_start,
        PLANNED_RELOAD_END_1: e.stop_1_parts_reload_end,
        // DD_PICKUP_1: e.stop_1_delay_pickup,
        // DD_UNLOAD_1: e.stop_1_delay_unload,
        SCANNED_ACTUAL_1: e.stop_1_actual,
        PU_2: e.stop_2_name,
        PU_2_NACODE: e.stop_2_nacode,
        PU_2_CACODE: e.stop_2_cacode,
        PU_2_MTMCODE: e.stop_2_mtmcode,
        PLANNED_RELOAD_START_2: e.stop_2_parts_reload_start,
        PLANNED_RELOAD_END_2: e.stop_2_parts_reload_end,
        // DD_PICKUP_2: e.stop_2_delay_pickup,
        // DD_UNLOAD_2: e.stop_2_delay_unload,
        SCANNED_ACTUAL_2: e.stop_2_actual,
        PU_3: e.stop_3_name,
        PU_3_NACODE: e.stop_3_nacode,
        PU_3_CACODE: e.stop_3_cacode,
        PU_3_MTMCODE: e.stop_3_mtmcode,
        PLANNED_RELOAD_START_3: e.stop_3_parts_reload_start,
        PLANNED_RELOAD_END_3: e.stop_3_parts_reload_end,
        // DD_PICKUP_3: e.stop_3_delay_pickup,
        // DD_UNLOAD_3: e.stop_3_delay_unload,
        SCANNED_ACTUAL_3: e.stop_3_actual,
        PU_4: e.stop_4_name,
        PU_4_NACODE: e.stop_4_nacode,
        PU_4_CACODE: e.stop_4_cacode,
        PU_4_MTMCODE: e.stop_4_mtmcode,
        PLANNED_RELOAD_START_4: e.stop_4_parts_reload_start,
        PLANNED_RELOAD_END_4: e.stop_4_parts_reload_end,
        // DD_PICKUP_4: e.stop_4_delay_pickup,
        // DD_UNLOAD_4: e.stop_4_delay_unload,
        SCANNED_ACTUAL_4: e.stop_4_actual,
        PU_5: e.stop_5_name,
        PU_5_NACODE: e.stop_5_nacode,
        PU_5_CACODE: e.stop_5_cacode,
        PU_5_MTMCODE: e.stop_5_mtmcode,
        PLANNED_RELOAD_START_5: e.stop_5_parts_reload_start,
        PLANNED_RELOAD_END_5: e.stop_5_parts_reload_end,
        // DD_PICKUP_5: e.stop_5_delay_pickup,
        // DD_UNLOAD_5: e.stop_5_delay_unload,
        SCANNED_ACTUAL_5: e.stop_5_actual,
        PU_6: e.stop_6_name,
        PU_6_NACODE: e.stop_6_nacode,
        PU_6_CACODE: e.stop_6_cacode,
        PU_6_MTMCODE: e.stop_6_mtmcode,
        PLANNED_RELOAD_START_6: e.stop_6_parts_reload_start,
        PLANNED_RELOAD_END_6: e.stop_6_parts_reload_end,
        // DD_PICKUP_6: e.stop_6_delay_pickup,
        // DD_UNLOAD_6: e.stop_6_delay_unload,
        SCANNED_ACTUAL_6: e.stop_6_actual,
        PU_7: e.stop_7_name,
        PU_7_NACODE: e.stop_7_nacode,
        PU_7_CACODE: e.stop_7_cacode,
        PU_7_MTMCODE: e.stop_7_mtmcode,
        PLANNED_RELOAD_START_7: e.stop_7_parts_reload_start,
        PLANNED_RELOAD_END_7: e.stop_7_parts_reload_end,
        // DD_PICKUP_7: e.stop_7_delay_pickup,
        // DD_UNLOAD_7: e.stop_7_delay_unload,
        SCANNED_ACTUAL_7: e.stop_7_actual,
        PU_8: e.stop_8_name,
        PU_8_NACODE: e.stop_8_nacode,
        PU_8_CACODE: e.stop_8_cacode,
        PU_8_MTMCODE: e.stop_8_mtmcode,
        PLANNED_RELOAD_START_8: e.stop_8_parts_reload_start,
        PLANNED_RELOAD_END_8: e.stop_8_parts_reload_end,
        // DD_PICKUP_8: e.stop_8_delay_pickup,
        // DD_UNLOAD_8: e.stop_8_delay_unload,
        SCANNED_ACTUAL_8: e.stop_8_actual,
        PU_9: e.stop_9_name,
        PU_9_NACODE: e.stop_9_nacode,
        PU_9_CACODE: e.stop_9_cacode,
        PU_9_MTMCODE: e.stop_9_mtmcode,
        PLANNED_RELOAD_START_9: e.stop_9_parts_reload_start,
        PLANNED_RELOAD_END_9: e.stop_9_parts_reload_end,
        // DD_PICKUP_9: e.stop_9_delay_pickup,
        // DD_UNLOAD_9: e.stop_9_delay_unload,
        SCANNED_ACTUAL_9: e.stop_9_actual,
        PU_10: e.stop_10_name,
        PU_10_NACODE: e.stop_10_nacode,
        PU_10_CACODE: e.stop_10_cacode,
        PU_10_MTMCODE: e.stop_10_mtmcode,
        PLANNED_RELOAD_START_10: e.stop_10_parts_reload_start,
        PLANNED_RELOAD_END_10: e.stop_10_parts_reload_end,
        // DD_PICKUP_10: e.stop_10_delay_pickup,
        // DD_UNLOAD_10: e.stop_10_delay_unload,
        SCANNED_ACTUAL_10: e.stop_10_actual,
        YARD: e.yard_name,
        YARD_NACODE: e.yard_nacode,
        YARD_CACODE: e.yard_cacode,
        YARD_MTMCODE: e.yard_mtmcode,
        YARD_ARRIVAL_START: e.yard_arrival_start,
        YARD_ARRIVAL_END: e.yard_arrival_end,
        YARD_ACTUAL: e.yard_arrival_actual,
        UNLOAD_START: e.unload_start,
        UNLOAD_END: e.unload_end,
        // DD_UNLOAD: e.delay_unload,
        UNLOAD_ACTUAL:
          e.route_type == 'Sub Route' ? e.yard_arrival_actual : e.unload_actual,
      };

      exportData.push(obj);
    });
    this.excelService.exportAsExcelFile(
      exportData,
      'Export_Dashboard',
      headers
    );
  }

  dateFormatter(res) {
    return res
      ? DateTime.fromFormat(res, 'MM-dd-yyyy HH:mm:ss', {
        zone: this.constants.timeZones[this.currentTimeZone],
        setZone: true,
      }).toFormat(this.const_monhr) + ` (${this.currentTimeZone})`
      : null;
  }
  refreshGrid() {
    this.gridDataFetch();
  }
  autoRefresh() {
    this.autoRefreshInterval = 5 * 60;
    this.autoRefreshSubscription = interval(1000)
      .pipe(
        map((x) => x),
        shareReplay(1)
      )
      .subscribe(() => {
        if (this.autoRefreshInterval > 0) {
          this.autoRefreshInterval--;
        } else {
          this.gridDataFetch();
        }
      });
  }
  saveColumnPreference() {
    const toyotaGUID = localStorage.getItem('toyotaGUID');
    const fgaDetails: any = JSON.parse(sessionStorage.getItem('FGA'));
    const upn = fgaDetails?.user?.userPrincipalName;	
    this.ngxUiLoaderService?.start(CommonConstant.loader);
    this.successMessage = null;
    this.errorMessage = null;
    const data = this.preferenceData.map((item) => {
      return {
        // prefSeqId:this.preference[0].prefSeqId,
        prefSeqId: this.prefSeqId,
        colName: item.colName,
        name: item.name,
        colIndex: item.colIndex,
        hidden: item.hidden,
        width: item.width,
      };
    });
    this.dashboardService?.saveload(data, upn)?.subscribe(
      (_result) => {
        this.ngxUiLoaderService.stop(CommonConstant.loader);
        this.loadColumnPreferenceData();
        this.successMessage = 'User preferences are saved.';

        setTimeout(() => {
          this.successMessage = null;
          this.errorMessage = null;
        }, 5000);
      },
      (_error) => {
        this.ngxUiLoaderService.stop(CommonConstant.loader);
        this.showError(this.getApiErrorMessage(_error));
      }
    );
  }

  editEvent(body) {
    this.eventId = body.event_id;
    localStorage.setItem('eventId', this.eventId);
    const dialogRef = this.dialog?.open(EditEventComponent, {
      width: '850px',
      height: '600px',
      panelClass: 'edit-event-mat-dialog',
      data: {
        data: body,
      },
    });

    dialogRef.afterClosed()?.subscribe((result: any) => {
      this.ngxUiLoaderService.stop(CommonConstant.loader);

      if (result?.event == 'SaveEvent') {                         // NOSONAR
        if (result?.responseType == 'success') {                         // NOSONAR
          this.gridDataFetch();
        } else {
          console.info('error');
        }
      }
      if (result.event == 'onDeletePress') {                         // NOSONAR
        this.deleteEvent();
      }
    });
  }

  deleteEvent() {
    const toyotaGUID = localStorage.getItem('toyotaGUID');
    const dialogRef = this.dialog?.open(DeletePopupComponent, {
      data: {
        eventId: this.eventId,
        toyotaGUID: toyotaGUID,
      },
      width: '540px',
      // height: '290px'
    });
    dialogRef.afterClosed()?.subscribe((result: any) => {
      this.ngxUiLoaderService.stop(CommonConstant.loader);

      if (result?.event == 'SaveEvent') {
        if (result?.responseType == 'success') {
          this.gridDataFetch();
        } else {
          console.info('error');
        }
      }
    });
  }

  shouldhide(fields: string) {
    const row = this.preferenceData?.find((item: any) => item?.name == fields);                         // NOSONAR
    if (row?.name == fields && row?.hidden == false) {                         // NOSONAR
      return true;
    } else {
      return false;
    }
  }

  onModelUpdated(): void {
    this.sizeToFit();
  }

  sizeToFit() {
    this.gridApi?.sizeColumnsToFit();
  }

  paramsMapping(original: any[], current: any[]): string[] {
    if (current.length == 0 || current.length == original.length) { return ['*']; }                         // NOSONAR
    return current.map((value) => value.code);
  }

  eventParamsMapping(original: any[], current: any[]): string[] {
    if (current.length == 0 || current.length == original.length) { return ['*']; }                         // NOSONAR
    const event = current.filter((value) => value.code != 0);      // NOSONAR
    return event.map((value) => value.code);
  }

  findOnTimeSelected() {
    if (this.selectedEventStatusList.length > 0) {
      return false;
    } else {
      return ( this.selectedEventTypeList.length == 0 || this.selectedEventTypeList.length == this.eventTypeList.length || this.selectedEventTypeList.findIndex((value) => value.code == 0) != -1 );                         // NOSONAR
    }
  }
  findOnlyOnTimeSelected() {
    return ( this.selectedEventTypeList.length == 1 && this.selectedEventTypeList[0].code == 0 );                         // NOSONAR
  }

  searchClick() {
    this.gridDataFetch();
    this.gridApi?.setFilterModel(null);
    this.dataService.setData(null);
  }

  date_Const = 'MM/dd/yyyy'
  gridDataFetch() {
    this.maximumStops = 5;
    this.autoRefreshSubscription?.unsubscribe();
    this.context = {
      componentParent: this,
    };
    const toyotaGUID = localStorage.getItem('toyotaGUID');
    const params = {
      domicile: this.selectedDomiciles,
      namc: this.selectedNamcList,
      supplierType: this.selectedSupplierType,
      supplier: this.selectedSupplierNumberList,
      line: this.selectedLineList,
      dock: this.selectedDockList,
      partNumber: this.part ? this.partnumber() : [],
      lp: this.selectedLpList,
      status: this.selectedEventStatusList,
      event: this.selectedEventTypeList,
      problem: this.selectedProblemTypeList,
      from: this.datePipe.transform(this.fromDate, this.date_Const),
      to: this.datePipe.transform(this.toDate, this.date_Const),
      currentTz: this.currentTimeZone,
      tz: this.selectedTimeZone,
      dst: this.isDSTChecked,
    };
    if (this.partError.length != 0) {   // NOSONAR
      this.errorMessage = this.partError.join(" ");
      setTimeout(() => {
        this.successMessage = null;
        this.errorMessage = null;
      }, 8000);
      return;
    }
    if (this.fromDate < this.minDate || this.fromDate > this.maxDate || this.toDate < this.minDate || this.toDate > this.maxDate) {
      this.errorMessage = `The Date range must be in between ${this.datePipe.transform(this.minDate, this.date_Const)} and ${this.datePipe.transform(this.maxDate, this.date_Const)}`;
      setTimeout(() => {
        this.successMessage = null;
        this.errorMessage = null;
      }, 8000);
      return;
    }
    const today2 = DateTime.fromFormat(this.fromDate, this.year_const);
    const maxDate = today2.plus({ days: 5 });
    const max = maxDate.toFormat(this.year_const);
    if (this.toDate >= max) {
      this.errorMessage = `The Date range must be no more than 5 days apart`;
      setTimeout(() => {
        this.successMessage = null;
        this.errorMessage = null;
      }, 8000);
      return;
    }
    localStorage.setItem('filterParams', JSON.stringify(params));
    localStorage.setItem('filterParamsPart', this.part);
    const httpParams = {
      domicile: this.paramsMapping(this.domicileList, this.selectedDomiciles),
      namc: this.paramsMapping(this.namcList, this.selectedNamcList),
      supplierType: this.selectedSupplierType,
      supplier: this.paramsMapping(
        this.supplierNumber,
        this.selectedSupplierNumberList
      ),
      line: this.paramsMapping(this.lineList, this.selectedLineList),
      dock: this.paramsMapping(this.dockList, this.selectedDockList),
      partNumber: this.part ? this.partnumber() : [],
      lp: this.paramsMapping(this.lpList, this.selectedLpList),
      // status: this.paramsMapping(
      //   this.eventStatusList,
      //   this.selectedEventStatusList
      // ),
      event: this.eventParamsMapping(
        this.eventTypeList,
        this.selectedEventTypeList
      ),
      problem: this.paramsMapping(
        this.problemTypeList,
        this.selectedProblemTypeList
      ),
      from: this.datePipe.transform(this.fromDate, this.date_Const),
      to: this.datePipe.transform(this.toDate, this.date_Const),
      onTime: true,
      onlyOnTime: false,
    };
    this.autoRefreshEnabled = true;
    if (this.toDate >= this.fromDate) {
      this.ngxUiLoaderService.start(CommonConstant.loader);
      this.apicall(toyotaGUID, httpParams)

    } else {
      this.errorMessage = 'To date must be greater than or equal to from date';
      setTimeout(() => {
        this.successMessage = null;
        this.errorMessage = null;
      }, 5000);
    }
  }

  apicall(toyotaGUID, httpParams) {
    this.dashboardService
      .getDashboardGridData(toyotaGUID, httpParams)
      .subscribe(
        (response: any) => {
          this.currentTimeZone = 'EST'; this.displayRowData = [];
          this.displayRowData = response.map((item: any) => {
            let triggerData = this.masterSettingResponse.find(
              (value) => item.dispatch_nacode == value.domicile                          // NOSONAR
            );
            if (!triggerData) {
              triggerData = this.masterSettingResponse.find(
                (value) => 'DEFAULT' == value.domicile                          // NOSONAR
              );
            }
            this.getDynamicStopColumns(item);
            return {
              ...item,
              last_updated: this.dateFormatter(item.last_updated),
              unload_start: this.dateFormatter(item.unload_start),
              unload_end: this.dateFormatter(item.unload_end),
              eta: this.dateFormatter(item.eta),
              next_connection: this.dateFormatter(item.next_connection),
              redTrigger: triggerData ? triggerData.redTrigger : 60,
              yellowTrigger: triggerData ? triggerData.yellowTrigger : 30,
              updateTrigger: triggerData ? triggerData.updateTrigger : 30,
              snoozeDelay: triggerData ? triggerData.snoozeDelay : 20,
              order_number: '',
              namcList: this.namcList,
              unldtool: !this.namcList.includes({
                description: item.yard_nacode,
                code: item.yard_nacode,
              })
                ? true
                : null,
              currentDate: this.getTimezone(),
              route_status: this.statusWrap(
                item,
                triggerData?.yellowTrigger,
                triggerData?.redTrigger
              ),
              stop_1_parts_reload_start: this.dateFormatter(
                item.stop_1_parts_reload_start
              ),
              stop_1_parts_reload_end: this.dateFormatter(
                item.stop_1_parts_reload_end
              ),
              stop_1_actual: this.dateFormatter(item.stop_1_actual),

              stop_2_parts_reload_start: this.dateFormatter(
                item.stop_2_parts_reload_start
              ),
              stop_2_parts_reload_end: this.dateFormatter(
                item.stop_2_parts_reload_end
              ),
              stop_2_actual: this.dateFormatter(item.stop_2_actual),

              stop_3_parts_reload_start: this.dateFormatter(
                item.stop_3_parts_reload_start
              ),
              stop_3_parts_reload_end: this.dateFormatter(
                item.stop_3_parts_reload_end
              ),
              stop_3_actual: this.dateFormatter(item.stop_3_actual),

              stop_4_parts_reload_start: this.dateFormatter(
                item.stop_4_parts_reload_start
              ),
              stop_4_parts_reload_end: this.dateFormatter(
                item.stop_4_parts_reload_end
              ),
              stop_4_actual: this.dateFormatter(item.stop_4_actual),

              stop_5_parts_reload_start: this.dateFormatter(
                item.stop_5_parts_reload_start
              ),
              stop_5_parts_reload_end: this.dateFormatter(
                item.stop_5_parts_reload_end
              ),
              stop_5_actual: this.dateFormatter(item.stop_5_actual),

              stop_6_parts_reload_start: this.dateFormatter(
                item.stop_6_parts_reload_start
              ),
              stop_6_parts_reload_end: this.dateFormatter(
                item.stop_6_parts_reload_end
              ),
              stop_6_actual: this.dateFormatter(item.stop_6_actual),

              stop_7_parts_reload_start: this.dateFormatter(
                item.stop_7_parts_reload_start
              ),
              stop_7_parts_reload_end: this.dateFormatter(
                item.stop_7_parts_reload_end
              ),
              stop_7_actual: this.dateFormatter(item.stop_7_actual),

              stop_8_parts_reload_start: this.dateFormatter(
                item.stop_8_parts_reload_start
              ),
              stop_8_parts_reload_end: this.dateFormatter(
                item.stop_8_parts_reload_end
              ),
              stop_8_actual: this.dateFormatter(item.stop_8_actual),

              stop_9_parts_reload_start: this.dateFormatter(
                item.stop_9_parts_reload_start
              ),
              stop_9_parts_reload_end: this.dateFormatter(
                item.stop_9_parts_reload_end
              ),
              stop_9_actual: this.dateFormatter(item.stop_9_actual),

              stop_10_parts_reload_start: this.dateFormatter(
                item.stop_10_parts_reload_start
              ),
              stop_10_parts_reload_end: this.dateFormatter(
                item.stop_10_parts_reload_end
              ),
              stop_10_actual: this.dateFormatter(item.stop_10_actual),

              dispatch_start_date: this.dateFormatter(
                item.dispatch_start_date
              ),
              dispatch_end_date: this.dateFormatter(item.dispatch_end_date),

              yard_arrival_start: this.dateFormatter(item.yard_arrival_start),
              yard_arrival_end: this.dateFormatter(item.yard_arrival_end),
              yard_arrival_actual: this.dateFormatter(
                item.yard_arrival_actual
              ),
              stop_1_delay_pickup: this.dateFormatter(item.stop_1_delay_pickup),
              stop_1_delay_unload: this.dateFormatter(item.stop_1_delay_unload),
              stop_2_delay_pickup: this.dateFormatter(item.stop_2_delay_pickup),
              stop_2_delay_unload: this.dateFormatter(item.stop_2_delay_unload),
              stop_3_delay_pickup: this.dateFormatter(item.stop_3_delay_pickup),
              stop_3_delay_unload: this.dateFormatter(item.stop_3_delay_unload),
              stop_4_delay_pickup: this.dateFormatter(item.stop_4_delay_pickup),
              stop_4_delay_unload: this.dateFormatter(item.stop_4_delay_unload),
              stop_5_delay_pickup: this.dateFormatter(item.stop_5_delay_pickup),
              stop_5_delay_unload: this.dateFormatter(item.stop_5_delay_unload),
              stop_6_delay_pickup: this.dateFormatter(item.stop_6_delay_pickup),
              stop_6_delay_unload: this.dateFormatter(item.stop_6_delay_unload),
              stop_7_delay_pickup: this.dateFormatter(item.stop_7_delay_pickup),
              stop_7_delay_unload: this.dateFormatter(item.stop_7_delay_unload),
              stop_8_delay_pickup: this.dateFormatter(item.stop_8_delay_pickup),
              stop_8_delay_unload: this.dateFormatter(item.stop_8_delay_unload),
              stop_9_delay_pickup: this.dateFormatter(item.stop_9_delay_pickup),
              stop_9_delay_unload: this.dateFormatter(item.stop_9_delay_unload),
              stop_10_delay_pickup: this.dateFormatter(item.stop_10_delay_pickup),
              stop_10_delay_unload: this.dateFormatter(item.stop_10_delay_unload),
              groupBy: item.main_route + item.route_id,

              cellChange: this.cellChange,
            };
          });

          if (
            this.selectedEventStatusList.length == 0 || this.selectedEventStatusList.length == this.eventStatusList.length) {                          // NOSONAR
            // do nothing
          } else {
            const reqStatus = this.selectedEventStatusList.map(
              (val) => val.code
            );
            const data = this.displayRowData.filter((value) => {
              if (reqStatus.includes(value.route_status)) {
                return true;
              }
              return false;
            });
            this.displayRowData = data;
          }
          if (
            this.selectedLpList.length == 0 || this.selectedLpList.length == this.lpList.length) {                          // NOSONAR
            // do nothing
          } else {
            const reqStatus = this.selectedLpList.map((val) => val.description);
            const data = this.displayRowData.filter((value) => {
              if (reqStatus.includes(value.transportation_provider)) {
                return true;
              }
              return false;
            });
            this.displayRowData = data;
          }
          let requiredTz = this.selectedTimeZone + 'ST';
          if (this.isDSTChecked) {
            requiredTz = requiredTz.replace('S', 'D');
          }
          if (requiredTz != 'EST') { // NOSONAR
            this.convertTimeZone(requiredTz);
          }
          this.getColDefs();
          const existingRows: any[] = [];
          this.gridApi.forEachNode(node => existingRows.push(node.data));
          if (existingRows.length > 0) {
            this.gridApi.applyTransaction({ remove: existingRows });
          }
          this.gridApi.applyTransaction({ add: this.displayRowData });
          this.rowCount = this.gridApi.getDisplayedRowCount();
          this.gridApi?.redrawRows();
          if (this.displayRowData.length == 0) {                         // NOSONAR
            this.ngxUiLoaderService.stop(CommonConstant.loader);
            return;
          }
          this.getOrderNumbers(
            this.displayRowData.map((value) => value.route_id)
          );
          this.dataService.setData(null);
        },
        (_error) => {
          this.ngxUiLoaderService.stop(CommonConstant.loader);
          this.showError(this.getApiErrorMessage(_error));
        }
      );
  }

  private getApiErrorMessage(error: any): string {
    if (error?.status == 500) {  // NOSONAR
      return this.unexpectedApiErrorMessage;
    }
    return this.constants?.APIErrorMessage || this.unexpectedApiErrorMessage;
  }

  showError(msg, timeoutMs: number = 5000) {
    this.errorMessage = msg
    setTimeout(() => {
      this.successMessage = null;
      this.errorMessage = null;
    }, timeoutMs);
  }
  getOrderNumbers(routeIds: number[]) {
    const orderNumbers: { [key: string]: any } = {};
    const partNumbers: { [key: string]: any } = {};
    const kanbanNumbers: { [key: string]: any } = {};

    this.dashboardService.getOrderNumbers(routeIds).subscribe(
      (response: any) => {
        for (const [key, value] of Object.entries(response)) {
          orderNumbers[key] = (value as any).orderNumbers;
          partNumbers[key] = (value as any).partNumbers;
          kanbanNumbers[key] = (value as any).kanbanNumbers;
        }
        for (let i = 0; i < this.displayRowData.length; i++) {
          this.displayRowData[i].order_number =
            orderNumbers[this.displayRowData[i].route_id];
          this.displayRowData[i].part_number =
            partNumbers[this.displayRowData[i].route_id];
          this.displayRowData[i].kanban_number =
            kanbanNumbers[this.displayRowData[i].route_id];
        }
        this.ngxUiLoaderService.stop(CommonConstant.loader);
        if (this.autoRefreshEnabled) {
          this.autoRefresh();
        }
        this.gridApi.applyTransaction({ update: this.displayRowData });

      },
      (_error) => {
        this.ngxUiLoaderService.stop(CommonConstant.loader);
        this.showError(this.getApiErrorMessage(_error));
      }
    );
  }

  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
    this.displayRowData = [];
    this.gridApi.applyTransaction({ add: this.displayRowData });
    this.rowCount = this.gridApi.getDisplayedRowCount();
    this.gridApi?.redrawRows();
    if (this.gridApi?.setColumnDefs) {
      this.gridApi.setColumnDefs(this.columnDefs);
    }
  }

  onRowClicked(event: RowClickedEvent) {
    const eventId = event.data?.event_id;
    if (!eventId || eventId == null) {  // NOSONAR
      return;
    }

    localStorage.setItem('eventId', eventId);
    localStorage.setItem('route', event.data.route);
    localStorage.setItem('run', event.data.run);
    const arrival = event.data.arrival
      ? event.data.arrival.substring(0, 10)
      : '';
    localStorage.setItem('arrival', arrival);
    localStorage.setItem('region', event.data.region);
    const dashboardFilters = {
      gridFilters: this.gridFilters,
    };
    this.dataService.setData(dashboardFilters);
    this.router?.navigate(['/dashboard/event']);
  }
  onFilterChanged(params: FilterChangedEvent): void {
    this.setText('#lbTotalPages', this.gridApi.paginationGetTotalPages());
    this.rowCount = params.api?.getDisplayedRowCount();
    const check = document.getElementById('lbTotalPages').innerHTML;
    if (this.rowCount == 0 && Number(check) == 0) {  // NOSONAR
      document.getElementById('lbCurrentPage').innerHTML = '0';
    }
    const gridFilters = this.gridApi.getFilterModel();
    this.gridFilters = gridFilters;
  }
  valueChange(event) {
    console.info(event)
  }

  goToNexpage() {
    this.gridApi.paginationGoToNextPage();
  }
  goToPreviousPage() {
    this.gridApi.paginationGoToPreviousPage();
  }
  goToFirstPage() {
    this.gridApi.paginationGoToFirstPage();
  }
  goToLastPage() {
    this.gridApi.paginationGoToLastPage();
  }

  getCurrentPage(): boolean {
    this.currentPageNo = this.gridApi?.paginationGetCurrentPage();
    if (this.currentPageNo == 0) {  // NOSONAR
      this.currentPageBoolean = true;
    } else {
      this.currentPageBoolean = false;
    }
    return this.currentPageBoolean;
  }
  isLastPage(): boolean {
    this.totalPage = Number(this.gridApi?.paginationGetTotalPages());
    this.currentPageForTotalPage =
      Number(this.gridApi?.paginationGetCurrentPage()) + 1;
    if (this.totalPage == this.currentPageForTotalPage) {  // NOSONAR
      this.isLastPageFound = true;
    } else {
      this.isLastPageFound = false;
    }
    return this.isLastPageFound;
  }
  onPaginationChanged() {
    if (this.gridApi) {
      this.setText(
        '#lbCurrentPage',
        this.gridApi.paginationGetCurrentPage() + 1
      );
      this.setText('#lbTotalPages', this.gridApi.paginationGetTotalPages());
      this.setLastButtonDisabled(!this.gridApi.paginationIsLastPageFound());
    }
  }
  setText(selector: string, text: any) {
    if (this.rowCount > 0) {
      (document.querySelector(selector) as any).innerHTML = text;
    } else {
      (document.querySelector(selector) as any).innerHTML = 0;
    }
  }
  setLastButtonDisabled(_disabled: boolean) {
    this.isLastPageFound = true;
  }
  onPageSizeChanged(event: any) {
    if (event.target.value == 'ALL') {  // NOSONAR
      this.paginationPageSize = event.target.value;
      this.gridApi?.paginationSetPageSize(Number(this.displayRowData.length));
    } else {
      this.paginationPageSize = event.target.value;
      this.gridApi?.paginationSetPageSize(Number(event.target.value));
    }
  }
  addEvent() {
    const dashboardFilters = {
      gridFilters: this.gridFilters,
    };
    this.dataService.setData(dashboardFilters);
    this.router.navigate(['/dashboard/addEvent']);
  }

  partNumberChanged(_$event: Event) {
    if (this.part.length == 0) {  // NOSONAR
      this.partError = [];
      return;
    }
    const a = this.part.split(',');
    const errors: string[] = [];
    a.forEach(value => {
      if (value.indexOf("*") != -1) { // NOSONAR
        if (value.indexOf("*") != value.lastIndexOf("*")) { // NOSONAR
          errors.push("Only 1 occurence of * allowed.");
        }
        if (value.length < 5) {
          errors.push("At Least First 4 Character of Part Number is Mandatory.");
        }
      } else if (value.length != 12) { // NOSONAR
        errors.push("A fully valid Part Number is of 12 character. Or include \"*\" if partial Part Number provided.");
      }
    });
    this.partError = errors;
  }

  partnumber() {
    const a = this.part.split(',');
    return a;
  }

  OpenuploadDelayedDispatchPopup() {
    this.dialog?.open(DelayDispatchComponent, {
      width: '850px',
      height: '600px',
      panelClass: 'edit-event-mat-dialog'
    })
  }

  onFileSelected(event: any) {
    this.ngxUiLoaderService.start(CommonConstant.loader);
    const file: File = event.target.files[0];
    this.fileName = file.name;
    this.upload = false;
    const extension = this.fileName.substring(this.fileName.lastIndexOf('.'));
    if (extension.toLowerCase() == '.csv') {  // NOSONAR
      this.dashboardService.uploadDelayedDispatchFile(file).subscribe(
        (response) => {
          this.delayedDispatchRes = response;
          if (this.delayedDispatchRes.status == 200) {  // NOSONAR
            this.ngxUiLoaderService.stop(CommonConstant.loader);
            this.upload = true;
            this.successMessage = "Delayed Dispatch file Submitted"

            setTimeout(() => {
              this.successMessage = null;
              this.errorMessage = null;
            }, 5000);
          }
          else {
            this.upload = false;
            this.errorMessage = this.file_msg;

          }
        },
        (_error) => {
          this.ngxUiLoaderService.stop(CommonConstant.loader);
          this.upload = false;
          this.showError(this.getApiErrorMessage(_error));
        }
      )
    } else {
      this.upload = false;
      this.errorMessage = 'Can accept only .xlsx and .xls';
    }
  }

  async newonFileSelected(event: any) {
    this.ngxUiLoaderService.start(CommonConstant.loader);
    const file: File = event.target.files[0];
    this.fileName = file.name;
    this.upload = false;
    const extension = this.fileName.substring(this.fileName.lastIndexOf('.'));
    if (extension.toLowerCase() == '.csv') {  // NOSONAR
      const parsedFileName = this.fileName
        ?.replace(/\s+/g, '_') // Replace spaces with underscore
        ?.replace(/[^a-zA-Z0-9._]/g, '_'); // Replace all non-alphanumeric/safe characters with underscore
      this.selectedFileName = `${generateRandomString()}_${parsedFileName}`;
      this.selectedFilePath = `AET/DelayedDispatch/${this.selectedFileName}`;
  const delayedDispatchSocketTimeoutMs = Math.max(FILE_UPLOAD_TIMEOUT, 120000);
      try {
        this.webSocketService.connect();
        await this.webSocketService.waitUntilSocketConnected();
        console.info(
          'WebSocket connected:',
          this.webSocketService.isSocketConnected()
        );
        this.webSocketService.sendMessage(
          // JSON.stringify({
          { fileName: this.selectedFilePath }
          // })
        );
        const url = `${environment.FILE_UPLOAD_URI}/${this.selectedFilePath}`;
        const fgaDetails: any = JSON.parse(sessionStorage.getItem('FGA'));
        const upn = fgaDetails?.user?.userPrincipalName;
        const roles = fgaDetails?.roles;
        const guid = fgaDetails?.user?.userId;

        const isAdmin = roles?.some(r => r.displayName == 'AET Admin') ? true : false;  // NOSONAR
        const token = sessionStorage.getItem('accessToken') || sessionStorage.getItem('idToken');

        const uploadHeaders: any = {
          'Content-Type': file?.type || 'text/csv', // Set file content type
          'x-auth-token': token || '',
          'x-amz-meta-userid': upn || '',
          'x-amz-meta-isAdmin': String(isAdmin),
          'x-amz-meta-guid': guid || '',
          'x-amz-meta-authtoken': token || '',
          'x-amz-meta-originalfilename': file?.name || '',
          'x-amz-meta-clientbuild': 'lios-aet-mfe-dd-v3',
        };

        console.info('DelayedDispatch upload path:', this.selectedFilePath);
        console.info('DelayedDispatch upload headers keys:', Object.keys(uploadHeaders));

        const response = await fetch(url, {
          method: 'PUT',
          headers: uploadHeaders,
          body: file,
        });

        if (!response.ok) {
          const responseText = await response.text().catch(() => '');
          console.info('DelayedDispatch upload failed:', {
            status: response.status,
            statusText: response.statusText,
            responseText,
          });
          this.errorMessage = responseText
            ? `Failed to upload file (${response.status}): ${responseText}`
            : `Failed to upload file (${response.status})!`;
          this.webSocketService.closeConnection();
          return;
        }

        this.webSocketService
          .receiveMessages()
          .pipe(
            // If no message is received within 25 seconds, throw TimeoutError
            timeout({
              each: delayedDispatchSocketTimeoutMs,
            }),
            takeWhile( (msg) => msg.status != 'success' && msg.status != 'failed' && msg.status != 'error', true ),  // NOSONAR
            catchError((err) => {
              if (err.name == 'TimeoutError') {  // NOSONAR
                console.info(
                  `No message received in ${delayedDispatchSocketTimeoutMs / 1000
                  } seconds. Closing connection.`
                );
                this.webSocketService.closeConnection();
                this.ngxUiLoaderService.stop(CommonConstant.loader);
                this.upload = false;
                this.errorMessage =
                  'Upload was received, but processing confirmation timed out. Please retry in a moment or contact IS Service Desk if this continues.';
              } else {
                console.info('WebSocket error:', err);
                this.ngxUiLoaderService.stop(CommonConstant.loader);
                this.errorMessage = 'Failed to upload file. Please re-upload the file.';
              }
              return EMPTY; // Stop further emissions
            })
          )
          .subscribe((messages: any) => {
            console.info(messages, "messages from Lambda");

            const status = String(messages?.status || '').toLowerCase();
            const backendResp = messages.backendResponse;
            if (!backendResp && (status == 'registered' || status == 'progress')) { // NOSONAR
              this.successMessage = messages?.message || 'File received. Processing upload...';
              this.errorMessage = null;
              return;
            }

            if (!backendResp && messages?.message) {
              this.successMessage = messages.message;
              this.errorMessage = null;
              return;
            }

            if (!backendResp && !messages?.message) {
              // Non-terminal payload without backend response; keep socket alive.
              return;
            }
            try {
              if (backendResp) {
                // Check backend API response for success/failure

                this.delayedDispatchRes = backendResp;
                if (this.delayedDispatchRes.status == 200) {  // NOSONAR
                  this.ngxUiLoaderService.stop(CommonConstant.loader);
                  this.upload = true;
                  this.successMessage = "Delayed Dispatch file Submitted"

                  setTimeout(() => {
                    this.successMessage = null;
                    this.errorMessage = null;
                  }, 5000);
                }
                else {
                  this.upload = false;
                  this.errorMessage = this.file_msg;

                }
                this.ngxUiLoaderService.stop(CommonConstant.loader);

              }
            }
            catch {
              this.ngxUiLoaderService.stop(CommonConstant.loader);
              this.upload = false;
              this.errorMessage = this.file_msg;
              this.webSocketService.closeConnection();
              return;
            }
            this.ngxUiLoaderService.stop(CommonConstant.loader);
            this.webSocketService.closeConnection();
          })
      } catch (err) {
        this.upload = false;
        console.info('Unexpected upload exception:', err);
        this.ngxUiLoaderService.stop(CommonConstant.loader);
        this.webSocketService.closeConnection();
        this.errorMessage = 'An unexpected error occurred. Please retry. Contact IS Service Desk if error persists'
      }
    } else {
      this.upload = false;
      this.errorMessage = 'Can accept only .csv';
    }
  }

  // isAllSelected(): boolean {
  //   return this.selectedDomiciles?.length == this.domicileList?.length;
  // }
  isAllSelected(option: any, list: any): boolean {
    return option?.length == list?.length;  // NOSONAR
  }

  // isIndeterminate(): boolean {
  //   return this.selectedDomiciles?.length > 0 &&
  //          this.domicileList?.length > 0 &&
  //          this.domicileList?.length < this.selectedDomiciles?.length;
  // }
  isIndeterminate(option: any, list: any): boolean {
    return option?.length > 0 &&
      list?.length > 0 &&
      option?.length < list?.length;
  }

  // toggleSelectAll(event: any): void {
  //   if (event.checked) {
  //     this.selectedDomiciles = [...this.domicileList];
  //   } else {
  //     this.selectedDomiciles = [];
  //   }
  // }
  toggleSelectAll(event: any, options, list: any): void {
    if (event.checked) {
      this[options] = [...list];
    } else {
      this[options] = [];
    }
  }




}

function getStyle(status: string, actual: any, eta: any) {
  if (status == 'lightgreen') {  // NOSONAR
    return { color: 'black', backgroundColor: 'lightgreen' };
  }

  if (status == 'yellow') {  // NOSONAR
    if (actual) {
      return { color: 'black', backgroundColor: 'yellow' };
    }
    if (eta) {
      return { color: 'black', backgroundColor: 'amber' };
    }
    return { color: 'white', backgroundColor: 'grey' };
  }

  // default (red case)
  if (actual) {
    return { color: 'white', backgroundColor: 'red' };
  }
  if (eta) {
    return { color: 'black', backgroundColor: 'amber' };
  }
  return { color: 'white', backgroundColor: 'grey' };
}
